// 订舱查询-订舱编辑页面
<template>
    <div class="main-center" style="margin-top: 80px;">
        <!--订舱信息卡片-->
        <div class="cardBox">
            <div class="cardTitle flex flex-align">
                <img src="../../assets/image/icon/order1.svg" alt="">
                <span>{{$t("bookingSpace.booking.bookingInfo")}}</span>
            </div>
            <div class="cardBody">
                <!--船舶信息【不可编辑】-->
                <div class="flex flex-space-around margin-bottom">
                    <!--船名【取自船期，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.main.vesselCode')}}</span>
                        </div>
                        <el-input v-model="bookingHead.vesselCode"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  readonly/>
                    </div>
                    <!--航次【取自船期，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.main.voyageNo')}}</span>
                        </div>
                        <el-input v-model="bookingHead.voyageNo"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  readonly/>
                    </div>
                    <!--航段【取自船期，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.main.voyageLeg')}}</span>
                        </div>
                        <el-input v-model="bookingHead.voyageLeg"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  readonly/>
                    </div>
                    <!--开航日期【取自船期，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.main.saillingDate')}}</span>
                        </div>
                        <el-date-picker v-model="bkRouting1.saillingDate" type="date" class="dateInput1"
                                        :placeholder="getPlaceHolder($t('common.pleaseSelectDate'))"
                                        readonly/>
                    </div>
                </div>

                <!--订舱信息-->
                <div class="flex flex-space-around margin-bottom">
                    <!--订舱号-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("bookingSpace.booking.bkNo")}}</span>
                        </div>
                        <el-input v-model="bookingHead.bkNo"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999" :readonly="getReadOnlyFlag"
                                  @input="formatUpperNoChinese('bookingHead','bkNo',bookingHead.bkNo,0,15)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bookingHead.bkNo || '').length }}/15</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bookingHead.bkNo']" class="field-error-tip">
                            {{fieldErrors['bookingHead.bkNo']}}
                        </div>
                    </div>
                    <!--提单号（订舱确认后系统自动生成，不可编辑）-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("bookingSpace.booking.blNo")}}</span>
                        </div>
                        <el-input v-model="bookingHead.blNo"
                                  :placeholder="getPlaceHolder($t('common.autoGenerate'))"
                                  readonly/>
                    </div>
                    <!--订舱状态【流程自动控制，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("bookingSpace.booking.bookingStatus")}}</span>
                        </div>
                        <el-select v-model="bookingHead.bookingStatus"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   disabled
                                   @focus="bookingStatusFocus">
                            <el-option v-for="item in bookingStatusOptions"
                                       :key="item.codeValue" :label="getDisplayValue(item)" :value="item.codeValue">
                                <span style="float: left">{{item.displayValue}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValueCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--订舱类型-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("bookingSpace.booking.bookingType")}}</span>
                        </div>
                        <el-select v-model="bookingHead.bookingType"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   :disabled="getReadOnlyFlag"
                                   @focus="bookingTypeFocus">
                            <el-option v-for="item in bookingTypeOptions"
                                       :key="item.codeValue"
                                       :label="item.displayValueCn"
                                       :value="item.codeValue"/>
                        </el-select>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--运输条款-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("bookingSpace.booking.transportationTerms")}}</span>
                        </div>
                        <el-select v-model="bookingHead.transportationTerms"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   clearable filterable default-first-option :disabled="getReadOnlyFlag"
                                   @focus="transportationTermsFocus">
                            <el-option v-for="item in transportationTermsOptions"
                                       :key="item.serviceModeCode"
                                       :label="item.serviceModeCode"
                                       :value="item.serviceModeCode">
                                <span style="float: left">{{item.serviceModeCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.serviceModeDesc}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--付费方式-->
                    <div class="inputName">
                        <div class="inputName-title"><span
                                class="redColor">{{$t("bookingSpace.booking.paidType")}}</span>
                        </div>
                        <el-select v-model="bookingHead.paidType"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   clearable :disabled="getReadOnlyFlag"
                                   @focus="paidTypeFocus">
                            <el-option v-for="item in paidTypeOptions"
                                       :key="item.codeValue"
                                       :label="item.displayValueCn"
                                       :value="item.codeValue">
                                <span style="float: left">{{item.displayValueCn}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--船开前协议号-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="blueColor">{{$t("bookingSpace.booking.agreementNo")}}</span>
                        </div>
                        <el-input v-model="bookingHead.agreementNo"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999" :readonly="getReadOnlyFlag"
                                  @input="formatUpperNoChinese('bookingHead','agreementNo',bookingHead.agreementNo,0,50)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bookingHead.agreementNo || '').length }}/50</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bookingHead.agreementNo']" class="field-error-tip">
                            {{fieldErrors['bookingHead.agreementNo']}}
                        </div>
                    </div>
                    <!--业务员-->
                    <div class="inputName">
                      <div class="inputName-title">
                        <span>{{$t("bookingSpace.booking.sales")}}</span>
                      </div>
                      <el-input v-model="bookingHead.sales"
                                :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                :maxlength="9999" :readonly="getReadOnlyFlag"
                                @input="handleSalesInput">
                        <template slot="suffix">
                          <span class="custom-word-limit">{{ (bookingHead.sales || '').length }}/20</span>
                        </template>
                      </el-input>
                      <div v-if="fieldErrors['bookingHead.sales']" class="field-error-tip">
                        {{fieldErrors['bookingHead.sales']}}
                      </div>
                    </div>
                    <!--询价单位 【取自客户代码，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("bookingSpace.booking.applicantUnit")}}</span>
                        </div>
                        <el-input v-model="bkExtend.applicantUnit"
                                  readonly/>
                    </div>
                </div>
                <!--地点信息-->
                <div class="flex flex-space-around margin-bottom">
                    <!--接货地-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.place.por')}}</span>
                        </div>
                        <el-select v-model="bookingHead.por"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   clearable filterable default-first-option :disabled="getReadOnlyFlag"
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode"
                                       :label="item.portCode"
                                       :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--装货港【取自船期，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.place.portFrom')}}</span>
                        </div>
                        <el-select v-model="bookingHead.pol"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   disabled
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode"
                                       :label="item.portCode"
                                       :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--卸货港【取自船期，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.place.portTo')}}</span>
                        </div>
                        <el-select v-model="bookingHead.pod"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   disabled
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode"
                                       :label="item.portCode"
                                       :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--目的地-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.place.del')}}</span>
                        </div>
                        <el-select v-model="bookingHead.del"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   clearable filterable default-first-option :disabled="getBlStatusConfirmFlag"
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode"
                                       :label="item.portCode"
                                       :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!--港口选择提示信息-->
                <el-alert
                    type="info"
                    :closable="false"
                    show-icon
                    class="port-selection-alert"
                    style="margin-bottom: 20px;">
                    <div slot="default" style="text-align: left; line-height: 1.8; white-space: pre-line;">
                        {{ $t('bookingSpace.place.portSelectionTipContent') }}
                    </div>
                </el-alert>
                <!--前程运输信息-->
                <div class="flex flex-space-around margin-bottom">
                    <!--支线船名-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.branch.branchVesselCode')}}</span>
                        </div>
                        <el-input v-model="bkRoutingPre.vesselName"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999" :readonly="getReadOnlyFlag"
                                  @input="formatUpperNoChinese('bkRoutingPre','vesselName',bkRoutingPre.vesselName,0,50)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bkRoutingPre.vesselName || '').length }}/50</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bkRoutingPre.vesselName']" class="field-error-tip">
                            {{fieldErrors['bkRoutingPre.vesselName']}}
                        </div>
                    </div>
                    <!--支线航次-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.branch.branchVoyageNo')}}</span>
                        </div>
                        <el-input v-model="bkRoutingPre.voyageNo"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999" :readonly="getReadOnlyFlag"
                                  @input="formatUpperNoChinese('bkRoutingPre','voyageNo',bkRoutingPre.voyageNo,0,20)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bkRoutingPre.voyageNo || '').length }}/20</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bkRoutingPre.voyageNo']" class="field-error-tip">
                            {{fieldErrors['bkRoutingPre.voyageNo']}}
                        </div>
                    </div>
                    <!--支线航段-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.branch.branchVoyageLeg')}}</span>
                        </div>
                        <el-input v-model="bkRoutingPre.voyageLeg"
                                  :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                  :maxlength="9999" :readonly="getReadOnlyFlag"
                                  @input="formatUpperNoChinese('bkRoutingPre','voyageLeg',bkRoutingPre.voyageLeg,0,5)">
                            <template slot="suffix">
                                <span class="custom-word-limit">{{ (bkRoutingPre.voyageLeg || '').length }}/5</span>
                            </template>
                        </el-input>
                        <div v-if="fieldErrors['bkRoutingPre.voyageLeg']" class="field-error-tip">
                            {{fieldErrors['bkRoutingPre.voyageLeg']}}
                        </div>
                    </div>
                    <!--支线开航时间-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.branch.branchSaillingDate')}}</span>
                        </div>
                        <el-date-picker v-model="bkRoutingPre.saillingDate" type="date" class="dateInput1"
                                        :placeholder="getPlaceHolder($t('common.pleaseSelectDate'))"
                                        clearable :readonly="getReadOnlyFlag"/>
                    </div>
                    <!--支线承运人-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.branch.branchCarrier')}}</span>
                        </div>
                        <el-select v-model="bkRoutingPre.carrier"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   clearable filterable default-first-option :disabled="getReadOnlyFlag"
                                   allow-create
                                   @focus="carrierFocus">
                            <el-option v-for="item in carrierOptions"
                                       :key="item.codeValue"
                                       :label="item.codeValue"
                                       :value="item.codeValue">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!--【注释】-->
                <div style="font-size: 14px;margin-bottom: 5px">
                    <span class="redColor">{{$t('bookingSpace.branch.note')}}</span>
                </div>
            </div>
        </div>

        <!--提单信息卡片-->
        <div class="cardBox">
            <div class="cardTitle flex flex-align">
                <img src="../../assets/image/icon/order2.svg" alt="">
                <span>{{$t('bookingSpace.bl.blInfo')}}</span>
            </div>
            <div class="cardBody">
                <div class="flex flex-space-around margin-bottom">
                    <!--提单类型-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.bl.deliveryDocumentMethod')}}</span>
                        </div>
                        <el-select v-model="bookingHead.deliveryDocumentMethod"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   clearable :disabled="getReadOnlyFlag">
                            <el-option v-for="item in deliveryMethodOptions"
                                       :key="item.codeValue"
                                       :label="getDisplayValue(item)"
                                       :value="item.codeValue"
                                       :title="getFullMeaning(item)">
                            </el-option>
                        </el-select>
                    </div>
                    <!--签单地点-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.bl.deliveryDocumentPlace')}}</span>
                        </div>
                        <el-select v-model="bookingHead.deliveryDocumentPlace"
                                   :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                   clearable filterable default-first-option :disabled="getReadOnlyFlag"
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode"
                                       :label="item.portCode"
                                       :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--签单份数【默认为3份，不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.bl.deliveryDocumentQuantity')}}</span>
                        </div>
                        <el-input v-model.number="bookingHead.deliveryDocumentQuantity"
                                  disabled/>
                    </div>
                    <!--付费地点【不可编辑】-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.bl.paidPalce')}}</span>
                        </div>
                        <el-select v-model="bookingHead.paidPalce"
                                   placeholder=""
                                   clearable filterable default-first-option disabled
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode"
                                       :label="item.portCode"
                                       :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
        </div>

        <!--人员信息卡片【分两栏左右显示】-->
        <div class="cardBox">
            <el-row>
                <!--1.发货人信息-->
                <el-col style="width: 50%;">
                    <div class="cardTitle flex flex-align">
                        <img src="../../assets/image/icon/order3.svg" alt="">
                        <span>{{$t('bookingSpace.shipperInfo')}}</span>
                    </div>
                    <div class="cardBody">
                        <!--发货人客户名称-->
                        <div class="flex flex-space-around margin-bottom">
                            <div class="flex inputName">
                                <div class="inputName-title">
                                    <span>{{$t('bookingSpace.shipper')}}</span>
                                </div>
                                <div style="position: relative; width: 100%;">
                                    <el-input v-model="shipper.customerName" type="textarea" :rows="3"
                                              :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                              :maxlength="9999" :disabled="getReadOnlyFlag"
                                              @input="formatUpperNoChinese('shipper','customerName',shipper.customerName,0,210)"/>
                                    <div class="textarea-word-limit">{{ (shipper.customerName || '').length }}/210</div>
                                </div>
                                <div v-if="fieldErrors['shipper.customerName']" class="field-error-tip">
                                    {{fieldErrors['shipper.customerName']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.addressPrintFlag" type="checkbox" :value=true  :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.address')}}</span>
                                </div>
                                <el-input v-model="shipper.address"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('shipper','address',shipper.address)"/>
                                <div v-if="fieldErrors['shipper.address']" class="field-error-tip">
                                    {{fieldErrors['shipper.address']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.cityPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.city')}}</span>
                                </div>
                                <el-input v-model="shipper.city"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('shipper','city',shipper.city)"/>
                                <div v-if="fieldErrors['shipper.city']" class="field-error-tip">
                                    {{fieldErrors['shipper.city']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.provinceCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.provinceCode')}}</span>
                                </div>
                                <el-input v-model="shipper.provinceCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('shipper','provinceCode',shipper.provinceCode)"/>
                                <div v-if="fieldErrors['shipper.provinceCode']" class="field-error-tip">
                                    {{fieldErrors['shipper.provinceCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.provinceNamePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.provinceName')}}</span>
                                </div>
                                <el-input v-model="shipper.provinceName"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('shipper','provinceName',shipper.provinceName)"/>
                                <div v-if="fieldErrors['shipper.provinceName']" class="field-error-tip">
                                    {{fieldErrors['shipper.provinceName']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.postCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.postCode')}}</span>
                                </div>
                                <el-input v-model="shipper.postCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('shipper','postCode',shipper.postCode)"/>
                                <div v-if="fieldErrors['shipper.postCode']" class="field-error-tip">
                                    {{fieldErrors['shipper.postCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.countryCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.countryCode')}}</span>
                                </div>
                                <el-input v-model="shipper.countryCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('shipper','countryCode',shipper.countryCode)"/>
                                <div v-if="fieldErrors['shipper.countryCode']" class="field-error-tip">
                                    {{fieldErrors['shipper.countryCode']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.telPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.tel')}}</span>
                                </div>
                                <el-input v-model="shipper.tel"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('shipper','tel',shipper.tel)"/>
                                <div v-if="fieldErrors['shipper.tel']" class="field-error-tip">
                                    {{fieldErrors['shipper.tel']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.emailPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.email')}}</span>
                                </div>
                                <el-input v-model="shipper.email"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('shipper','email',shipper.email)"/>
                                <div v-if="fieldErrors['shipper.email']" class="field-error-tip">
                                    {{fieldErrors['shipper.email']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="shipper.enterpriseCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.enterpriseCode')}}</span>
                                </div>
                                <el-input v-model="shipper.enterpriseCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('shipper','enterpriseCode',shipper.enterpriseCode)"/>
                                <div v-if="fieldErrors['shipper.enterpriseCode']" class="field-error-tip">
                                    {{fieldErrors['shipper.enterpriseCode']}}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <!--收货人信息-->
                <el-col style="width: 50%;">
                    <div class="cardTitle flex flex-align">
                        <img src="../../assets/image/icon/order4.svg" alt="">
                        <span>{{$t('bookingSpace.consigneeInfo')}}</span>
                    </div>
                    <div class="cardBody">
                        <!--收货人客户名称-->
                        <div class="flex flex-space-around margin-bottom">
                            <div class="flex inputName ">
                                <div class="inputName-title">
                                    <span>{{$t('bookingSpace.consignee')}}</span>
                                </div>
                                <div style="position: relative; width: 100%;">
                                    <el-input v-model="consignee.customerName" type="textarea" :rows="3"
                                              :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                              :maxlength="9999" :disabled="getReadOnlyFlag"
                                              @input="formatUpperNoChinese('consignee','customerName',consignee.customerName,0,245)"/>
                                    <div class="textarea-word-limit">{{ (consignee.customerName || '').length }}/245</div>
                                </div>
                                <div v-if="fieldErrors['consignee.customerName']" class="field-error-tip">
                                    {{fieldErrors['consignee.customerName']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.addressPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.address')}}</span>
                                </div>
                                <el-input v-model="consignee.address"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('consignee','address',consignee.address)"/>
                                <div v-if="fieldErrors['consignee.address']" class="field-error-tip">
                                    {{fieldErrors['consignee.address']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.cityPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.city')}}</span>
                                </div>
                                <el-input v-model="consignee.city"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('consignee','city',consignee.city)"/>
                                <div v-if="fieldErrors['consignee.city']" class="field-error-tip">
                                    {{fieldErrors['consignee.city']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.provinceCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.provinceCode')}}</span>
                                </div>
                                <el-input v-model="consignee.provinceCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('consignee','provinceCode',consignee.provinceCode)"/>
                                <div v-if="fieldErrors['consignee.provinceCode']" class="field-error-tip">
                                    {{fieldErrors['consignee.provinceCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.provinceNamePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.provinceName')}}</span>
                                </div>
                                <el-input v-model="consignee.provinceName"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('consignee','provinceName',consignee.provinceName)"/>
                                <div v-if="fieldErrors['consignee.provinceName']" class="field-error-tip">
                                    {{fieldErrors['consignee.provinceName']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.postCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.postCode')}}</span>
                                </div>
                                <el-input v-model="consignee.postCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('consignee','postCode',consignee.postCode)"/>
                                <div v-if="fieldErrors['consignee.postCode']" class="field-error-tip">
                                    {{fieldErrors['consignee.postCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.countryCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.countryCode')}}</span>
                                </div>
                                <el-input v-model="consignee.countryCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('consignee','countryCode',consignee.countryCode)"/>
                                <div v-if="fieldErrors['consignee.countryCode']" class="field-error-tip">
                                    {{fieldErrors['consignee.countryCode']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.telPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.tel')}}</span>
                                </div>
                                <el-input v-model="consignee.tel"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('consignee','tel',consignee.tel)"/>
                                <div v-if="fieldErrors['consignee.tel']" class="field-error-tip">
                                    {{fieldErrors['consignee.tel']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.emailPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.email')}}</span>
                                </div>
                                <el-input v-model="consignee.email"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('consignee','email',consignee.email)"/>
                                <div v-if="fieldErrors['consignee.email']" class="field-error-tip">
                                    {{fieldErrors['consignee.email']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="consignee.enterpriseCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.enterpriseCode')}}</span>
                                </div>
                                <el-input v-model="consignee.enterpriseCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('consignee','enterpriseCode',consignee.enterpriseCode)"/>
                                <div v-if="fieldErrors['consignee.enterpriseCode']" class="field-error-tip">
                                    {{fieldErrors['consignee.enterpriseCode']}}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <!--通知人1信息-->
                <el-col style="width: 50%;margin-top: 5px">
                    <div class="cardTitle flex flex-align">
                        <img src="../../assets/image/icon/order5.svg" alt="">
                        <span>{{$t('bookingSpace.notify1Info')}}</span>
                    </div>
                    <div class="cardBody">
                        <!--通知人1客户名称-->
                        <div class="flex flex-space-around margin-bottom">
                            <div class="flex inputName ">
                                <div class="inputName-title">
                                    <span>{{$t('bookingSpace.notifier1')}}</span>
                                </div>
                                <div style="position: relative; width: 100%;">
                                    <el-input v-model="notifier1.customerName" type="textarea" :rows="3"
                                              :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                              :maxlength="9999" :disabled="getReadOnlyFlag"
                                              @input="formatUpperNoChinese('notifier1','customerName',notifier1.customerName,0,245)"/>
                                    <div class="textarea-word-limit">{{ (notifier1.customerName || '').length }}/245</div>
                                </div>
                                <div v-if="fieldErrors['notifier1.customerName']" class="field-error-tip">
                                    {{fieldErrors['notifier1.customerName']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.addressPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.address')}}</span>
                                </div>
                                <el-input v-model="notifier1.address"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier1','address',notifier1.address)"/>
                                <div v-if="fieldErrors['notifier1.address']" class="field-error-tip">
                                    {{fieldErrors['notifier1.address']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.cityPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.city')}}</span>
                                </div>
                                <el-input v-model="notifier1.city"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier1','city',notifier1.city)"/>
                                <div v-if="fieldErrors['notifier1.city']" class="field-error-tip">
                                    {{fieldErrors['notifier1.city']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.provinceCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.provinceCode')}}</span>
                                </div>
                                <el-input v-model="notifier1.provinceCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier1','provinceCode',notifier1.provinceCode)"/>
                                <div v-if="fieldErrors['notifier1.provinceCode']" class="field-error-tip">
                                    {{fieldErrors['notifier1.provinceCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.provinceNamePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.provinceName')}}</span>
                                </div>
                                <el-input v-model="notifier1.provinceName"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier1','provinceName',notifier1.provinceName)"/>
                                <div v-if="fieldErrors['notifier1.provinceName']" class="field-error-tip">
                                    {{fieldErrors['notifier1.provinceName']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.postCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.postCode')}}</span>
                                </div>
                                <el-input v-model="notifier1.postCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier1','postCode',notifier1.postCode)"/>
                                <div v-if="fieldErrors['notifier1.postCode']" class="field-error-tip">
                                    {{fieldErrors['notifier1.postCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.countryCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.countryCode')}}</span>
                                </div>
                                <el-input v-model="notifier1.countryCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier1','countryCode',notifier1.countryCode)"/>
                                <div v-if="fieldErrors['notifier1.countryCode']" class="field-error-tip">
                                    {{fieldErrors['notifier1.countryCode']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.telPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.tel')}}</span>
                                </div>
                                <el-input v-model="notifier1.tel"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier1','tel',notifier1.tel)"/>
                                <div v-if="fieldErrors['notifier1.tel']" class="field-error-tip">
                                    {{fieldErrors['notifier1.tel']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.emailPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.email')}}</span>
                                </div>
                                <el-input v-model="notifier1.email"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier1','email',notifier1.email)"/>
                                <div v-if="fieldErrors['notifier1.email']" class="field-error-tip">
                                    {{fieldErrors['notifier1.email']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier1.enterpriseCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.enterpriseCode')}}</span>
                                </div>
                                <el-input v-model="notifier1.enterpriseCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier1','enterpriseCode',notifier1.enterpriseCode)"/>
                                <div v-if="fieldErrors['notifier1.enterpriseCode']" class="field-error-tip">
                                    {{fieldErrors['notifier1.enterpriseCode']}}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <!--通知人2信息-->
                <el-col style="width: 50%;margin-top: 5px">
                    <div class="cardTitle flex flex-align">
                        <img src="../../assets/image/icon/order5.svg" alt="">
                        <span>{{$t('bookingSpace.notify2Info')}}</span>
                    </div>
                    <div class="cardBody">
                        <!--通知人2客户名称-->
                        <div class="flex flex-space-around margin-bottom">
                            <div class="inputName ">
                                <div class="inputName-title">
                                    <span>{{$t('bookingSpace.notifier2')}}</span>
                                </div>
                                <div style="position: relative; width: 100%;">
                                    <el-input v-model="notifier2.customerName" type="textarea" :rows="3"
                                              :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                              :maxlength="9999" :disabled="getReadOnlyFlag"
                                              @input="formatUpperNoChinese('notifier2','customerName',notifier2.customerName,0,245)"/>
                                    <div class="textarea-word-limit">{{ (notifier2.customerName || '').length }}/245</div>
                                </div>
                                <div v-if="fieldErrors['notifier2.customerName']" class="field-error-tip">
                                    {{fieldErrors['notifier2.customerName']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.addressPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.address')}}</span>
                                </div>
                                <el-input v-model="notifier2.address"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier2','address',notifier2.address)"/>
                                <div v-if="fieldErrors['notifier2.address']" class="field-error-tip">
                                    {{fieldErrors['notifier2.address']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.cityPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.city')}}</span>
                                </div>
                                <el-input v-model="notifier2.city"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier2','city',notifier2.city)"/>
                                <div v-if="fieldErrors['notifier2.city']" class="field-error-tip">
                                    {{fieldErrors['notifier2.city']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.provinceCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.provinceCode')}}</span>
                                </div>
                                <el-input v-model="notifier2.provinceCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier2','provinceCode',notifier2.provinceCode)"/>
                                <div v-if="fieldErrors['notifier2.provinceCode']" class="field-error-tip">
                                    {{fieldErrors['notifier2.provinceCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.provinceNamePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.provinceName')}}</span>
                                </div>
                                <el-input v-model="notifier2.provinceName"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier2','provinceName',notifier2.provinceName)"/>
                                <div v-if="fieldErrors['notifier2.provinceName']" class="field-error-tip">
                                    {{fieldErrors['notifier2.provinceName']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.postCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.postCode')}}</span>
                                </div>
                                <el-input v-model="notifier2.postCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier2','postCode',notifier2.postCode)"/>
                                <div v-if="fieldErrors['notifier2.postCode']" class="field-error-tip">
                                    {{fieldErrors['notifier2.postCode']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.countryCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.countryCode')}}</span>
                                </div>
                                <el-input v-model="notifier2.countryCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier2','countryCode',notifier2.countryCode)"/>
                                <div v-if="fieldErrors['notifier2.countryCode']" class="field-error-tip">
                                    {{fieldErrors['notifier2.countryCode']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.telPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.tel')}}</span>
                                </div>
                                <el-input v-model="notifier2.tel"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier2','tel',notifier2.tel)"/>
                                <div v-if="fieldErrors['notifier2.tel']" class="field-error-tip">
                                    {{fieldErrors['notifier2.tel']}}
                                </div>
                            </div>
                        </div>
                        <div class="flex margin-bottom">
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.emailPrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.email')}}</span>
                                </div>
                                <el-input v-model="notifier2.email"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier2','email',notifier2.email)"/>
                                <div v-if="fieldErrors['notifier2.email']" class="field-error-tip">
                                    {{fieldErrors['notifier2.email']}}
                                </div>
                            </div>
                            <div class="inputName">
                                <div class="inputName-title">
                                    <input v-model="notifier2.enterpriseCodePrintFlag" type="checkbox" :value=true :disabled="getReadOnlyFlag"/>
                                    <span>{{$t('bookingSpace.customer.enterpriseCode')}}</span>
                                </div>
                                <el-input v-model="notifier2.enterpriseCode"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                          clearable :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('notifier2','enterpriseCode',notifier2.enterpriseCode)"/>
                                <div v-if="fieldErrors['notifier2.enterpriseCode']" class="field-error-tip">
                                    {{fieldErrors['notifier2.enterpriseCode']}}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <!--【注释】*以上国家代码、联系电话、邮件地址、企业代码输入信息将不显示在提单上-->
                    <div style="font-size: 14px;margin-bottom: 5px">
                        <span class="redColor">{{$t('bookingSpace.customer.note')}}</span>
                    </div>
                </el-col>
            </el-row>
        </div>

        <!--货物信息卡片-->
        <div class="cardBox">
            <div class="cardTitle flex flex-align">
                <img src="../../assets/image/icon/order11.svg" alt="">
                <span>{{$t('bookingSpace.cargo.cargoInfo')}}</span>
            </div>
            <div class="cardBody">
                <div class="flex flex-space-around" style="height: 205px">
                    <div style="width:40%;margin-top:2px;">
                        <!--货描-->
                        <div class="inputName">
                            <div class="inputName-title">
                                <span class="redColor">{{$t('bookingSpace.cargo.cargoDesc')}}</span>
                            </div>
                            <div style="position: relative; width: 100%;">
                                <el-input v-model="bkCargo.cargoDesc" type="textarea" :rows="9"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                          :maxlength="isSGP ? undefined : 3990" :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('bkCargo','cargoDesc',bkCargo.cargoDesc,0,isSGP ? null : 3990)"/>
                                <div class="textarea-word-limit">{{ (bkCargo.cargoDesc || '').length }}/{{isSGP ? '不限字数' : 3990}}</div>
                            </div>
                            <div v-if="fieldErrors['bkCargo.cargoDesc']" class="field-error-tip">
                                {{fieldErrors['bkCargo.cargoDesc']}}
                            </div>
                        </div>
                    </div>
                    <div style="width:32%;margin-top:2px">
                        <!--唛头-->
                        <div class="inputName ">
                            <div class="inputName-title">
                                <span class="redColor">{{$t('bookingSpace.cargo.shippingMark')}}</span>
                            </div>
                            <div style="position: relative; width: 100%;">
                                <el-input v-model="bkCargo.shippingMark" type="textarea" :rows="9"
                                          :placeholder="getPlaceHolder($t('common.pleaseEnterContent'))"
                                          :maxlength="9999" :disabled="getReadOnlyFlag"
                                          @input="formatUpperNoChinese('bkCargo','shippingMark',bkCargo.shippingMark,0,3150)"/>
                                <div class="textarea-word-limit">{{ (bkCargo.shippingMark || '').length }}/3150</div>
                            </div>
                            <div v-if="fieldErrors['bkCargo.shippingMark']" class="field-error-tip">
                                {{fieldErrors['bkCargo.shippingMark']}}
                            </div>
                        </div>
                    </div>
                    <div style="width:28%;margin-top:2px">
                        <!--件数-->
                        <div class="inputName margin-bottom3">
                            <div class="inputName-title">
                                <span>{{$t('bookingSpace.cargo.quantity')}}</span>
                            </div>
                            <el-input v-model.number="bkCargo.quantity"
                                      :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                      clearable :disabled="getReadOnlyFlag"/>
                        </div>
                        <!-- 毛重与净重并排 -->
                        <div class="flex" style="gap: 12px">
                            <!--毛重(KG)-->
                            <div class="inputName margin-bottom3">
                                <div class="inputName-title">
                                    <span>{{$t('bookingSpace.cargo.grossWeight')}}</span>
                                </div>
                                <el-input v-model="bkCargo.grossWeight"
                                      :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                      clearable :disabled="getReadOnlyFlag"
                                      @input="formatNumber('bkCargo','grossWeight',bkCargo.grossWeight,3)"/>
                            </div>
                            <!-- 净重(KG) -->
                            <div class="inputName margin-bottom3">
                                <div class="inputName-title">
                                    <span>{{$t('bookingSpace.cargo.netWeight')}}</span>
                                </div>
                                <el-input v-model="bkCargo.netWeight"
                                      :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                      clearable :disabled="getReadOnlyFlag"
                                      @input="formatNumber('bkCargo','netWeight',bkCargo.netWeight,3)"/>
                            </div>
                        </div>
                        <!--尺寸-->
                        <div class="inputName margin-bottom3">
                            <div class="inputName-title">
                                <span class="redColor">{{$t('bookingSpace.cargo.cargoSize')}}</span>
                            </div>
                            <el-input v-model="bkCargo.cargoSize"
                                      :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                      clearable :disabled="getReadOnlyFlag"
                                      @input="formatNumber('bkCargo','cargoSize',bkCargo.cargoSize,4)"/>
                        </div>
                        <el-row>
                            <el-col style="width: 40%">
                                <!--包装类型【只读状态】-->
                                <div class="inputName margin-bottom3">
                                    <el-col :span="7" style="width: 90%">
                                        <div class="inputName-title">
                                            <span class="redColor">{{$t('bookingSpace.cargo.packageType')}}</span>
                                        </div>
                                        <el-input v-model="bkCargo.packageType"
                                                  :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                                  readonly :disabled="getReadOnlyFlag"/>
                                    </el-col>
                                    <el-col :span="7" style="width: 10%">
                                        <!--包装类型弹框-->
                                        <el-popover ref="packageTypePopover" class="popover" width="600" trigger="click"
                                                    placement="right"
                                                    @hide="packageTypeShow=false">
                                            <div class="flex flex-space-between">
                                                <!--包装类型代码查询条件-->
                                                <div class="inputName-left">
                                                    <div class="inputName-title-left">
                                                        <span>{{$t('bookingSpace.cargo.packageTypeSearch')}}</span>
                                                    </div>
                                                    <el-input v-model="popover.packageType"
                                                              :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                                              clearable
                                                              @input="formatUpperNoChinese('popover','packageType',popover.packageType)"/>
                                                </div>
                                                <!--包装类型弹框查询按钮-->
                                                <el-button class="popoverInner" size="small" icon="el-icon-search"
                                                           @click="packageTypeSearch">
                                                    {{findButton}}
                                                </el-button>
                                            </div>
                                            <div class="flex flex-space-between">
                                                <!--包装类型名称查询条件-->
                                                <div class="inputName-left">
                                                    <div class="inputName-title-left">
                                                        <span>{{$t('bookingSpace.cargo.packageDescSearch')}}</span>
                                                    </div>
                                                    <el-input v-model="popover.packageDesc"
                                                              :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                                              clearable
                                                              @input="formatUpperNoChinese('popover','packageDesc',popover.packageDesc)"/>
                                                </div>
                                                <!--包装类型弹框关闭按钮-->
                                                <el-button class="popoverInner" size="small" icon="el-icon-warning-outline"
                                                           @click="closePopoverView">
                                                    {{closeButton}}
                                                </el-button>
                                            </div>
                                            <!--包装类型数据表格-->
                                            <el-table :data="packageTypedata" class="packageTypePopover"
                                                      style="width:100%;margin-top:5px"
                                                      max-height="300" highlight-current-row
                                                      :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                                                      :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                                                      :empty-text="$t('common.noData')"
                                                      @row-dblclick="popConfirm"
                                                      @row-click="popRowClick">
                                                <el-table-column width="80" type="index" label="序号"></el-table-column>
                                                <el-table-column width="120" prop="codeValue" label="包装类型代码"></el-table-column>
                                                <el-table-column width="400" prop="displayValue" label="包装类型名称"></el-table-column>
                                            </el-table>
                                            <div class="flex flex-space-between">
                                                <div class="topMargin flex1">
                                                    {{`共${popover.popTotal}条`}}
                                                </div>
                                                <el-button class="popoverInner" type="primary"
                                                           @click="popConfirm">
                                                    {{confirmButton}}
                                                </el-button>
                                                <div class="pagination flex1">
                                                    <el-pagination max-height="600" small layout="sizes,pager"
                                                                   :page-size="popover.popPageSize" :total="popover.popTotal"
                                                                   :page-sizes="[10, 20, 30, 40, 50]"
                                                                   :pager-count="popover.popPageCount"
                                                                   :current-page="popover.popPageNum"
                                                                   @size-change="popHandleSizeChange"
                                                                   @current-change="popHandleCurrentChange"/>
                                                </div>
                                            </div>
                                            <!--包装类型弹框显示按钮【页面数据只读时不显示】-->
                                            <img slot="reference" style="cursor:pointer" class="packageTypeButton"
                                                 src="../../assets/image/selectMore.png" v-show="!getReadOnlyFlag"/>
                                        </el-popover>
                                    </el-col>
                                </div>
                            </el-col>
                            <el-col style="width: 60%">
                                <!--包装描述-->
                                <div class="inputName margin-bottom3">
                                    <div class="inputName-title">
                                        <span class="redColor">{{$t('bookingSpace.cargo.packageDesc')}}</span>
                                    </div>
                                    <el-input v-model="bkCargo.packageDesc"
                                              :placeholder="getPlaceHolder($t('bookingSpace.cargo.packageDescPlaceholder'))"
                                              :disabled="getReadOnlyFlag" readonly/>
                                    <div v-if="fieldErrors['bkCargo.packageDesc']" class="field-error-tip">
                                        {{fieldErrors['bkCargo.packageDesc']}}
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div class="flex flex-space-around">
                    <!--特殊设置-->
                    <el-col style="width: 34%">
                        <div class="cardBody setting">
                            <ul class="flex">
                                <!--危险品信息-->
                                <el-popover placement="bottom" width="1000" trigger="click">
                                    <li class="flex flex-align" slot="reference">
                                        <input v-model="bookingHead.dgCheckFlag" type="checkbox" value=true :disabled="getReadOnlyFlag"
                                               @click="(($event) => {(validatePreInfo($event, 1))})"/>
                                        {{$t('bookingSpace.bkImos.bkImo')}}
                                    </li>
                                    <div class="position-right fullWidth">
                                        <!--危险品增加-->
                                        <img src="../../assets/image/icon/add1.svg" alt="" style="margin-right:8px"
                                             @click="addArray('bkImos')"
                                             v-show="!(getReadOnlyFlag) && bookingHead.dgCheckFlag">
                                        <!--危险品删除-->
                                        <img src="../../assets/image/icon/del1.svg" alt=""
                                             @click="removeArray('bkImos')"
                                             v-show="!(getReadOnlyFlag) && bookingHead.dgCheckFlag">
                                    </div>
                                    <!--危险品数据编辑表格-->
                                    <el-table class="table" :data="bkCargo.bkImos" style="width: 100%"
                                              :header-cell-style="{padding:'0px',height:'30px'}"
                                              :row-style="{height:'30px'}"
                                              :cell-style="{padding:'5px 0'}" :empty-text="$t('common.noData')">
                                        <el-table-column prop="classType" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.classType')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.classType" :disabled="getReadOnlyFlag"
                                                          @input="formatUpperNoChinese('bkImos','classType',scope.row.classType,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="unSeriseNo" label="UN No." min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.unSeriseNo')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.unSeriseNo" :disabled="getReadOnlyFlag"
                                                          @input="formatUpperNoChinese('bkImos','unSeriseNo',scope.row.unSeriseNo,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="label" label="label" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.label')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.label" :disabled="getReadOnlyFlag"
                                                          @input="formatUpperNoChinese('bkImos','label',scope.row.label,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="packageDesc" label="包装种类" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.packageDesc')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.packageDesc"
                                                           placeholder=" "
                                                           clearable :disabled="getReadOnlyFlag"
                                                           @focus="dgPackageGroupFocus">
                                                    <el-option v-for="item in dgPackageGroupOptions"
                                                               :key="item.codeValue"
                                                               :label="item.displayValue"
                                                               :value="item.codeValue"/>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="packageCode" label="包装类型" min-width="120" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.packageCode')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.packageCode"
                                                          :disabled="getReadOnlyFlag"
                                                          @input="formatUpperNoChinese('bkImos','packageCode',scope.row.packageCode,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="property" label="运输品名" min-width="120" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.property')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.property"
                                                          :disabled="getReadOnlyFlag"
                                                          @input="formatUpperNoChinese('bkImos','property',scope.row.property,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="componentDesc" label="化学品名" min-width="120" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.componentDesc')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.componentDesc" :disabled="getReadOnlyFlag"
                                                          @input="formatUpperNoChinese('bkImos','componentDesc',scope.row.componentDesc,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="emergencySeq" label="应急措施编号" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkImos.emergencySeq')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.emergencySeq" :disabled="getReadOnlyFlag"
                                                          @input="formatUpperNoChinese('bkImos','emergencySeq',scope.row.emergencySeq,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="emergencyTelNo" label="紧急联系" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.emergencyTelNo')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.emergencyTelNo" :disabled="getReadOnlyFlag"
                                                          @input="formatUpperNoChinese('bkImos','emergencyTelNo',scope.row.emergencyTelNo,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="quantity" label="件数" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.quantity')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.quantity" :disabled="getReadOnlyFlag"
                                                          oninput="value=value.replace(/[^0-9]/g,'')"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="grossWeight" label="毛重" min-width="115" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.grossWeight')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.grossWeight" :disabled="getReadOnlyFlag"
                                                          @input="formatNumber('bkImos','grossWeight',scope.row.grossWeight,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="netWeight" label="净重" min-width="115" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.netWeight')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.netWeight" :disabled="getReadOnlyFlag"
                                                          @input="formatNumber('bkImos','netWeight',scope.row.netWeight,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="flashPoint" label="闪点" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.flashPoint')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.flashPoint" :disabled="getReadOnlyFlag"
                                                          @input="formatNumber('bkImos','flashPoint',scope.row.flashPoint,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="rateBase" label="闪点单位" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.rateBase')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.rateBase"
                                                           placeholder=" "
                                                           clearable :disabled="getReadOnlyFlag"
                                                           @focus="rateBaseFocus">
                                                    <el-option v-for="item in rateBaseOptions"
                                                               :key="item.codeValue"
                                                               :label="item.displayValue"
                                                               :value="item.codeValue"/>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="isPolutionFlag" label="是否海污" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkImos.isPolutionFlag')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.isPolutionFlag"
                                                           placeholder=" "
                                                           clearable :disabled="getReadOnlyFlag">
                                                    <el-option :key="true" :label="$t('common.yes')" :value="true"/>
                                                    <el-option :key="false" :label="$t('common.no')" :value="false"/>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-popover>
                                <!--冷箱信息-->
                                <el-popover placement="bottom" width="400" trigger="click">
                                    <li class="flex flex-align" slot="reference">
                                        <input v-model="bookingHead.rfCheckFlag" type="checkbox" value=true :disabled="getReadOnlyFlag"
                                               @click="((val) => {(validatePreInfo(val, 2))})"/>{{$t('bookingSpace.bkReefers.bkReefer')}}
                                    </li>
                                    <div class="position-right fullWidth">
                                        <!--冷箱增加按钮-->
                                        <img src="../../assets/image/icon/add1.svg" alt="" style="margin-right:8px"
                                             @click="addArray('bkReefers')"
                                             v-show="!(getReadOnlyFlag) && bookingHead.rfCheckFlag">
                                        <!--冷箱删除按钮-->
                                        <img src="../../assets/image/icon/del1.svg" alt=""
                                             @click="removeArray('bkReefers')"
                                             v-show="!(getReadOnlyFlag) && bookingHead.rfCheckFlag">
                                    </div>
                                    <!--冷箱数据编辑表格-->
                                    <el-table class="table" :data="bkCargo.bkReefers" style="width: 100%"
                                              :header-cell-style="{padding:'0px',height:'30px'}"
                                              :row-style="{height:'30px'}"
                                              :cell-style="{padding:'5px 0'}"
                                              :empty-text="$t('common.noData')">
                                        <el-table-column prop="rateBase" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkReefers.rateBase')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.rateBase"
                                                           placeholder=" "
                                                           clearable :disabled="getReadOnlyFlag"
                                                           @focus="rateBaseFocus">
                                                    <el-option v-for="item in rateBaseOptions"
                                                               :key="item.codeValue"
                                                               :label="item.displayValue"
                                                               :value="item.codeValue"/>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="temperature" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkReefers.temperature')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.temperature" :disabled="getReadOnlyFlag"
                                                          @input="formatUpperNoChinese('bkReefers','temperature',scope.row.temperature,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="intakeNum" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkReefers.intakeNum')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.intakeNum" :disabled="getReadOnlyFlag"
                                                          @input="formatUpperNoChinese('bkReefers','intakeNum',scope.row.intakeNum,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-popover>
                                <!--SOC信息-->
                                <li class="flex flex-align">
                                    <input v-model="bookingHead.socCheckFlag" type="checkbox" value=true :disabled="getReadOnlyFlag"/>
                                    {{$t('bookingSpace.bkSoc')}}
                                </li>
                                <!--特种箱信息-->
                                <el-popover placement="bottom" width="1000" trigger="click">
                                    <li class="flex flex-align" slot="reference">
                                        <input v-model="bookingHead.akCheckFlag" type="checkbox" value=true :disabled="getReadOnlyFlag"/>
                                        {{$t('bookingSpace.bkAks.bkAk')}}
                                    </li>
                                    <div class="position-right fullWidth">
                                        <!--特种箱增加按钮-->
                                        <img src="../../assets/image/icon/add1.svg" alt="" style="margin-right:8px"
                                             @click="addArray('bkAks')"
                                             v-show="!(getReadOnlyFlag) && bookingHead.akCheckFlag">
                                        <!--特种箱删除按钮-->
                                        <img src="../../assets/image/icon/del1.svg" alt=""
                                             @click="removeArray('bkAks')"
                                             v-show="!(getReadOnlyFlag) && bookingHead.akCheckFlag">
                                    </div>
                                    <!--特种箱数据编辑表格-->
                                    <el-table class="table" :data="bookingHead.bkAks" style="width: 100%"
                                              :header-cell-style="{padding:'0px',height:'30px'}"
                                              :row-style="{height:'30px'}"
                                              :cell-style="{padding:'5px 0'}"
                                              :empty-text="$t('common.noData')">
                                        <el-table-column prop="containerType" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkAks.containerType')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.containerType"
                                                           :placeholder="getPlaceHolder($t('common.pleaseSelect'))"
                                                           clearable filterable default-first-option :disabled="getReadOnlyFlag"
                                                           @focus="containerTypeFocus">
                                                    <el-option v-for="item in containerTypeOptions"
                                                               :key="item.equipmentCode"
                                                               :label="item.equipmentCode"
                                                               :value="item.equipmentCode"/>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="akLength" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkAks.akLength')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.akLength" :disabled="getReadOnlyFlag"
                                                          @input="formatNumber('bkAks','akLength',scope.row.akLength,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="akWidth" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkAks.akWidth')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.akWidth" :disabled="getReadOnlyFlag"
                                                          @input="formatNumber('bkAks','akWidth',scope.row.akWidth,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="akHigth" min-width="100" align="center">
                                            <template slot="header">
                                                <span>{{$t('bookingSpace.bkAks.akHigth')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.akHigth" :disabled="getReadOnlyFlag"
                                                          @input="formatNumber('bkAks','akHigth',scope.row.akHigth,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="akGrossWeight" min-width="100" align="center">
                                            <template slot="header">
                                                <span class="redColor">*</span>
                                                <span>{{$t('bookingSpace.bkAks.akGrossWeight')}}</span>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.akGrossWeight" :disabled="getReadOnlyFlag"
                                                          @input="formatNumber('bkAks','akGrossWeight',scope.row.akGrossWeight,3,scope.$index)"/>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-popover>
                            </ul>
                        </div>
                    </el-col>
                    <el-col style="width:38%;margin-top: 16px">
                        <!--【注释】*如果有多个HSCODE都需要填写。例如: 1231542,423441,23465-->
                        <div style="font-size: 14px;">
                            <span class="redColor">{{$t('bookingSpace.cargo.hscodeTips')}}</span>
                        </div>
                    </el-col>
                    <el-col style="width:28%;margin-top: 18px">
                        <!--HsCode-->
                        <div class="inputName margin-bottom3">
                            <div class="inputName-title">
                                <span class="redColor">HS CODE</span>
                            </div>
                            <el-input v-model="bookingHead.hsCode"
                                      :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                      :maxlength="9999"
                                      clearable :disabled="getReadOnlyFlag"
                                      @input="formatUpperNoChinese('bookingHead','hsCode',bookingHead.hsCode,0,30)">
                                <template slot="suffix">
                                    <span class="custom-word-limit">{{ (bookingHead.hsCode || '').length }}/30</span>
                                </template>
                            </el-input>
                            <div v-if="fieldErrors['bookingHead.hsCode']" class="field-error-tip">
                                {{fieldErrors['bookingHead.hsCode']}}
                            </div>
                        </div>
                    </el-col>
                </div>
            </div>
        </div>

        <!--订舱预配箱卡片-->
        <div class="cardBox">
            <div class="cardTitle flex flex-space-between">
                <div>
                    <img src="../../assets/image/icon/order10.svg" alt="">
                    <span>{{$t('bookingSpace.preContainer.preContainerInfo')}}</span>
                </div>
                <!--订舱预配箱-增加按钮-->
                <el-button icon="el-icon-plus" class="blue-button" size="mini" :disabled="getBlStatusConfirmFlag"
                           @click="addBkPreContainer">
                    {{addButton}}
                </el-button>
            </div>
            <div class="cardBody">
                <div class="flex flex-space-around" v-for="(i,j) in bkPreContainers" :key="j">
                    <!--箱型-->
                    <div class="inputName margin-bottom">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.preContainer.containerType')}}</span>
                        </div>
                        <el-select v-model="i.containerType"
                                   :placeholder="$t('common.pleaseSelect')"
                                   clearable filterable default-first-option :disabled="getBlStatusConfirmFlag"
                                   @focus="containerTypeFocus">
                            <el-option v-for="item in containerTypeOptions"
                                       :key="item.equipmentCode"
                                       :label="item.equipmentCode"
                                       :value="item.equipmentCode">
                                <span style="float: left">{{item.equipmentCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.containerDesc}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--件数-->
                    <div class="inputName margin-bottom">
                        <div class="inputName-title">
                            <span>{{$t('bookingSpace.preContainer.quantity')}}</span>
                        </div>
                        <el-input v-model="i.quantity"
                                  :placeholder="$t('common.pleaseEnter')"
                                  clearable :disabled="getBlStatusConfirmFlag"
                                  oninput="value=value.replace(/[^0-9]/g,'')"/>
                    </div>
                    <!--货类-->
                    <div class="inputName margin-bottom">
                        <div class="inputName-title">
                            <span class="redColor">{{$t('bookingSpace.preContainer.cargoTypeCode')}}</span>
                        </div>
                        <el-select v-model="i.cargoTypeCode"
                                   :placeholder="$t('common.pleaseSelect')"
                                   clearable filterable default-first-option :disabled="getBlStatusConfirmFlag"
                                   @focus="cargoTypeFocus"
                                   @input="((val) => {validateCargoTypeCode(val,j)})">
                            <el-option v-for="item in cargoTypeOptions"
                                       :key="item.codeValue"
                                       :label="getDisplayValue(item)"
                                       :value="item.codeValue"/>
                        </el-select>
                    </div>
                    <!--订舱预配箱-删除按钮-->
                    <el-button icon="el-icon-delete" type="danger" size="mini" :disabled="getBlStatusConfirmFlag"
                               @click="removeBkPreContainer(i,j)">
                        {{deleteButton}}
                    </el-button>
                </div>
            </div>
        </div>

        <!--其他信息卡片-->
        <div class="flex fullWidth">
            <div class="cardBox lastCardBox2" style="width: 100%">
                <div class="cardTitle flex flex-align">
                    <img src="../../assets/image/icon/order9.svg" alt="">
                    <span>{{$t('bookingSpace.other.otherInfo')}}</span>
                </div>
                <div class="cardBody">
                    <div class="flex flex-space-around">
                        <!--订舱备注-->
                        <div class="inputName">
                            <div class="inputName-title">
                                <span>{{$t('bookingSpace.other.remark')}}</span>
                            </div>
                            <el-input v-model="bookingHead.remark"
                                      :placeholder="getPlaceHolder($t('common.pleaseEnter'))"
                                      clearable :disabled="getReadOnlyFlag"
                                      @input="formatUpper('bookingHead','remark',bookingHead.remark)"/>
                            <div v-if="fieldErrors['bookingHead.remark']" class="field-error-tip">
                                {{fieldErrors['bookingHead.remark']}}
                            </div>
                        </div>
                        <!--订舱拒绝【禁用状态，不可编辑，仅在订舱拒绝时显示】-->
                        <div class="inputName" v-show="bookingHead.bookingStatus == 8">
                            <div class="inputName-title">
                                <span>{{$t('bookingSpace.other.rejectReason')}}</span>
                            </div>
                            <el-input v-model="bookingHead.rejectReason"
                                      disabled/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--底部按钮组-->
        <div class="footer-group">
            <!--保存草稿按钮-->
            <el-button class="save-yellow-button" type="warning" :disabled="!getBookingHeadDraftFlag"
                       @click="returnSave">
                {{saveButton}}
            </el-button>
            <!--保存并发送船公司按钮-->
            <el-button class="save-blue-button" type="primary" :disabled="getBlStatusConfirmFlag"
                       @click="returnSend">
                {{saveAndSendButton}}
            </el-button>
            <!--拷贝新增按钮-->
            <el-button class="save-green-button" type="success"
                       @click="copyNewBtnClick">
                {{copyNewButton}}
            </el-button>
            <!--返回按钮-->
            <el-button class="return-button" type="info"
                       @click="returnPage">
                {{returnButton}}
            </el-button>
        </div>
        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>

<script>
    import {formatUpperNoChinese as formatUpperNoChineseOriginal, formatUpper as formatUpperOriginal} from "../../utils/formatInput";

    export default {
        name: 'bookingSpace',
        computed: {
            //设置页面只读状态 【仅在草稿状态和订舱拒绝状态下页面可编辑，其他状态仅目的地、订舱预配箱信息可编辑】
            getReadOnlyFlag() {
                return this.bookingHead.bookingStatus != 8
                    && this.bookingHead.bookingStatus != 9;
            },
            //控制【保存草稿】按钮可用状态【仅在草稿状态和订舱拒绝状态下可使用保存草稿按钮】
            getBookingHeadDraftFlag() {
                return this.bookingHead.bookingStatus == 9   //草稿
                    || this.bookingHead.bookingStatus == 8;  //拒绝
            },
            //控制【保存并发送船公司】按钮可用状态【当提单状态为确认状态时，不可使用保存并发送船公司按钮】
            getBlStatusConfirmFlag() {
                return this.bookingHead.blStatus == 1
            },
            /************************************ 页面按钮国际化信息 ***********************************/
            //保存草稿按钮
            saveButton() {
                return this.$t("common.saveButton");
            },
            //保存并发送船公司按钮
            saveAndSendButton() {
                return this.$t("common.saveAndSendButton");
            },
            //拷贝新增按钮
            copyNewButton() {
                return this.$t("common.copyNewButton");
            },
            //返回按钮
            returnButton() {
                return this.$t("common.returnButton");
            },
            //增加按钮
            addButton() {
                return this.$t("common.addButton");
            },
            //删除按钮
            deleteButton() {
                return this.$t("common.deleteButton");
            },
            //弹框搜索按钮
            findButton() {
                return this.$t("common.findButton");
            },
            //弹框关闭按钮
            closeButton() {
                return this.$t("common.closeButton");
            },
            //弹框确认按钮
            confirmButton() {
                return this.$t("common.confirmButton");
            },
            isSGP() {
              // 判断是否为“新加坡”主体
              const entityType = this.$apiUtils.getCurrentEntity();
              return entityType === "2";
            }
        },
        data() {
            return {
                fieldErrors: {},            //字段错误信息对象，用于存储各字段的校验错误提示
                isSaveClick: false,         //控制保存草稿按钮是否重复点击
                isSendClick: false,         //控制保存并发送按钮是否重复点击
                isPopSearchClick: false,    //控制包装类型弹框查询按钮是否重复点击
                packageTypeShow: false,     //控制包装类型弹框是否显示
                portOptions: [],            //港口下拉选项
                carrierOptions: [],         //承运人下拉选项
                bookingStatusOptions: [],   //订舱状态下拉选项
                paidTypeOptions: [],        //付费方式下拉选项
                bookingTypeOptions: [],     //订舱类型下拉选项
                blTypeOptions: [],          //提单类型下拉选项
                deliveryMethodOptions: [    //单证类型下拉选项
                    {codeValue: 1, displayValueCn: "正本提单", displayValue: "OBL"},
                    {codeValue: 2, displayValueCn: "海运单", displayValue: "SW"},
                    {codeValue: 3, displayValueCn: "电放提单", displayValue: "TLX"}
                ],
                transportationTermsOptions: [], //运输条款下拉选项
                cargoTypeOptions: [],           //货物类型下拉选项
                containerTypeOptions: [],       //箱型下拉选项
                rateBaseOptions: [],            //单位下拉选项
                dgPackageGroupOptions: [],      //危险品包装种类下拉选项
                customerNos: ["1", "2", "3", "4"],  //控制收发通折叠面板是否展开
                packageTypedata: [],            //货物包装类型数据
                popover: {                      //包装类型弹框
                    packageType: "",
                    packageDesc: "",
                    popTableSelection: [],
                    popTotal: 0,
                    popPageCount: 5,
                    popPageNum: 1,
                    popPageSize: 50,
                },
                //订舱数据
                bookingHead: {
                    bookingHeadId: "",
                    voyagePlanId: "",
                    //【订舱信息】
                    bkNo: "",
                    blNo: "",
                    bookingStatus: "",
                    bookingType: "",
                    transportationTerms: "",
                    paidType: "",
                    agreementNo: "",
                    sales: "",
                    //【提单信息】
                    // blType: null,
                    deliveryDocumentMethod: null,
                    deliveryDocumentPlace: "",
                    deliveryDocumentQuantity: "",
                    paidPalce: "",
                    //【地点信息】
                    por: "",
                    pol: "",
                    pod: "",
                    del: "",
                    transitPort: "",
                    //【船舶信息】
                    vesselCode: "",
                    vesselName: "",
                    vesselNameCn: "",
                    voyageNo: "",
                    voyageLeg: "",
                    saillingDate: "",
                    //【特殊设置】
                    dgCheckFlag: false,
                    rfCheckFlag: false,
                    socCheckFlag: false,
                    akCheckFlag: false,
                    //【其他信息】
                    remark: "",
                    rejectReason: "",
                    //【特种箱信息】
                    bkAks: [],
                    hsCode: "",
                    tsFlag: false,
                    transportType: 0    //运输类型（默认为"本港"）
                },
                //【舱单扩展信息】
                bkExtend: {
                    bkExtendId: "",
                    applicantUnit: "",
                    porName: "",
                    polName: "",
                    podName: "",
                    delName: ""
                },
                //【货物信息】
                bkCargo: {
                    bkCargoId: "",
                    quantity: "",
                    grossWeight: "",
                    cargoSize: "",
                    cargoDesc: "",
                    shippingMark: "",
                    packageType: "",
                    packageDesc: "",
                    //【危险品信息】
                    bkImos: [],
                    //【冷箱信息】
                    bkReefers: []
                },
                /*【发货人信息】*/
                shipper: {
                    bkCustomerId: "",
                    customerType: 0,        //客户类型0：发货人
                    companyName: "",
                    customerNameCatalogId: "",
                    customerNamePrintFlag: true,
                    address:"",
                    addressPrintFlag:false,
                    addressCatalogId:"",
                    city:"",
                    cityPrintFlag:false,
                    cityCatalogId:"",
                    provinceCode:"",
                    provinceCodePrintFlag:false,
                    provinceCodeCatalogId:"",
                    provinceName:"",
                    provinceNamePrintFlag:false,
                    provinceNameCatalogId:"",
                    postCode:"",
                    postCodePrintFlag:false,
                    postCodeCatalogId:"",
                    customerName: "",
                    countryCodeCatalogId: "",
                    countryCodePrintFlag: false,
                    countryCode: "",
                    telCatalogId: "",
                    telPrintFlag: false,
                    tel: "",
                    emailCatalogId: "",
                    emailPrintFlag: false,
                    email: "",
                    enterpriseCodeCatalogId: "",
                    enterpriseCodePrintFlag: false,
                    enterpriseCode: "",
                    printFlag: false,
                    otherCatalogs: []
                },
                /*【收货人信息】*/
                consignee: {
                    bkCustomerId: "",
                    customerType: 1,        //客户类型1：收货人
                    companyName: "",
                    customerNameCatalogId: "",
                    customerNamePrintFlag: true,
                    customerName: "",
                    address:"",
                    addressPrintFlag:false,
                    addressCatalogId:"",
                    city:"",
                    cityPrintFlag:false,
                    cityCatalogId:"",
                    provinceCode:"",
                    provinceCodePrintFlag:false,
                    provinceCodeCatalogId:"",
                    provinceName:"",
                    provinceNamePrintFlag:false,
                    provinceNameCatalogId:"",
                    postCode:"",
                    postCodePrintFlag:false,
                    postCodeCatalogId:"",
                    countryCodeCatalogId: "",
                    countryCodePrintFlag: false,
                    countryCode: "",
                    telCatalogId: "",
                    telPrintFlag: false,
                    tel: "",
                    emailCatalogId: "",
                    emailPrintFlag: false,
                    email: "",
                    enterpriseCodeCatalogId: "",
                    enterpriseCodePrintFlag: false,
                    enterpriseCode: "",
                    printFlag: false,
                    otherCatalogs: []
                },
                /*【通知人1信息】*/
                notifier1: {
                    bkCustomerId: "",
                    customerType: 2,        //客户类型2：通知人1
                    companyName: "",
                    customerNameCatalogId: "",
                    customerNamePrintFlag: true,
                    customerName: "",
                    address:"",
                    addressPrintFlag:false,
                    addressCatalogId:"",
                    city:"",
                    cityPrintFlag:false,
                    cityCatalogId:"",
                    provinceCode:"",
                    provinceCodePrintFlag:false,
                    provinceCodeCatalogId:"",
                    provinceName:"",
                    provinceNamePrintFlag:false,
                    provinceNameCatalogId:"",
                    postCode:"",
                    postCodePrintFlag:false,
                    postCodeCatalogId:"",
                    countryCodeCatalogId: "",
                    countryCodePrintFlag: false,
                    countryCode: "",
                    telCatalogId: "",
                    telPrintFlag: false,
                    tel: "",
                    emailCatalogId: "",
                    emailPrintFlag: false,
                    email: "",
                    enterpriseCodeCatalogId: "",
                    enterpriseCodePrintFlag: false,
                    enterpriseCode: "",
                    printFlag: false,
                    otherCatalogs: []
                },
                /*【通知人2信息】*/
                notifier2: {
                    bkCustomerId: "",
                    customerType: 3,        //客户类型3：通知人2
                    companyName: "",
                    customerNameCatalogId: "",
                    customerNamePrintFlag: true,
                    customerName: "",
                    address:"",
                    addressPrintFlag:false,
                    addressCatalogId:"",
                    city:"",
                    cityPrintFlag:false,
                    cityCatalogId:"",
                    provinceCode:"",
                    provinceCodePrintFlag:false,
                    provinceCodeCatalogId:"",
                    provinceName:"",
                    provinceNamePrintFlag:false,
                    provinceNameCatalogId:"",
                    postCode:"",
                    postCodePrintFlag:false,
                    postCodeCatalogId:"",
                    countryCodeCatalogId: "",
                    countryCodePrintFlag: false,
                    countryCode: "",
                    telCatalogId: "",
                    telPrintFlag: false,
                    tel: "",
                    emailCatalogId: "",
                    emailPrintFlag: false,
                    email: "",
                    enterpriseCodeCatalogId: "",
                    enterpriseCodePrintFlag: false,
                    enterpriseCode: "",
                    printFlag: false,
                    otherCatalogs: []
                },
                //【运输信息】
                bkRouting1: {
                    bkRoutingId: "",
                    tripNumber: 0,
                    lineType: 1,//0:支线 1:干线
                    vesselCode: "",
                    voyageNo: "",
                    voyageLeg: "",
                    saillingDate: "",
                    carrier: "",
                    serviceLineCode: "",
                    voyagePlanId: "",
                    portFrom: "",
                    portTo: "",
                    inTransportType: 0,
                    outTransportType: 0,
                    isNoticedFlag: false,
                    bookingStatus: null,
                    msn: ""
                },
                bkRoutingPre: {
                    bkRoutingId: "",
                    tripNumber: 0,
                    lineType: 0,//0:支线 1:干线
                    portFrom: "",
                    portTo: "",
                    serviceLineCode: "",
                    vesselCode: "",
                    vesselName: "",
                    voyageNo: "",
                    voyageLeg: "",
                    saillingDate: "",
                    carrier: "",
                    isNoticedFlag: false,
                    bookingStatus: null,
                    outTransportType: "",//出口运输类型
                    inTransportType: ""//进口运输类型
                },
                bkRoutingNext: {
                    bkRoutingId: "",
                    tripNumber: 0,
                    lineType: 0,//0:支线 1:干线
                    portFrom: "",
                    portTo: "",
                    vesselCode: "",
                    vesselName: "",
                    voyageNo: "",
                    voyageLeg: "",
                    saillingDate: "",
                    carrier: "",
                    isNoticedFlag: false,
                    bookingStatus: null,
                    outTransportType: "",   //出口运输类型
                    inTransportType: ""     //进口运输类型
                },
                bkRoutingTransit: {},
                //【订舱预配箱信息】
                bkPreContainers: [],
                deleteBkImos: [],           //待删除的危险品记录
                deleteBkReefers: [],        //待删除的冷箱记录
                deleteBkAks: [],            //待删除的特种箱记录
                deleteBkPreContainers: []   //待删除的订舱预配箱记录
            }
        },
        methods: {
            /**
             * 包装 formatUpperNoChinese 方法，确保 this 上下文正确
             */
            formatUpperNoChinese(parent, prop, value, index, maxLength) {
                // 确保 fieldErrors 对象存在
                if (!this.fieldErrors) {
                    this.$set(this, 'fieldErrors', {});
                }
                // 调用原始的格式化函数，this 会指向当前 Vue 实例
                return formatUpperNoChineseOriginal.call(this, parent, prop, value, index, maxLength);
            },
            /**
             * 包装 formatUpper 方法，确保 this 上下文正确
             */
            formatUpper(parent, prop, value, index) {
                // 确保 fieldErrors 对象存在
                if (!this.fieldErrors) {
                    this.$set(this, 'fieldErrors', {});
                }
                // 调用原始的格式化函数，this 会指向当前 Vue 实例
                return formatUpperOriginal.call(this, parent, prop, value, index);
            },
            /**
             * 获取字段错误信息
             * @param {string} parent - 父级属性
             * @param {string} prop - 当前属性
             * @param {number} index - 可选，数组索引
             * @returns {string} 错误信息，如果没有错误则返回空字符串
             */
            getFieldError(parent, prop, index) {
                const errorKey = index !== undefined ? `${parent}.${prop}.${index}` : `${parent}.${prop}`;
                return this.fieldErrors && this.fieldErrors[errorKey] ? this.fieldErrors[errorKey] : '';
            },

            /**
             * 业务员字段输入处理：仅限制长度为 20，允许中文和任意字符
             * @param {string} val - 当前输入的值
             */
            handleSalesInput(val) {
              // 1. 处理空值情况
              if (!val) {
                this.bookingHead.sales = '';
                // 清空可能的错误提示
                if (this.fieldErrors['bookingHead.sales']) {
                  this.$set(this.fieldErrors, 'bookingHead.sales', '');
                }
                return;
              }

              // 2. 长度校验与截断 (数据库 varchar(20))
              const maxLength = 20;
              if (val.length > maxLength) {
                // 截断字符串
                this.bookingHead.sales = val.substring(0, maxLength);


                // 弹出提示，可以取消下面注释：
                this.$set(this.fieldErrors, 'bookingHead.sales',this.$t('common.overLength',{maxLength:maxLength}));

                // // 确保 fieldErrors 中没有残留错误，因为我们已经强制截断了
                // if (this.fieldErrors['bookingHead.sales']) {
                //   this.$set(this.fieldErrors, 'bookingHead.sales', '');
                // }
              } else {
                // 3. 未超长，正常赋值
                this.bookingHead.sales = val;

                // 如果之前有错误（比如提交后报错），当用户修改时清空错误
                if (this.fieldErrors['bookingHead.sales']) {
                  this.$set(this.fieldErrors, 'bookingHead.sales', '');
                }
              }
            },

            /**
             * 控件默认显示文字设置
             */
            getPlaceHolder(defaultValue) {
                //仅草稿状态或订舱拒绝状态时可编辑页面数据
                return (this.bookingHead.bookingStatus == 8 || this.bookingHead.bookingStatus == 9) ? defaultValue : '';
            },

            /**
             * 提单类型 简称解释ToolTip
             */
            getFullMeaning(item) {
              const meanings = {
                '1': 'ORIGINAL BILL OF LADING',
                '2': 'SEA WAYBILL',
                '3': 'TELEX RELEASE B/L'
              };
              return localStorage.getItem('locale') == 'en' ? meanings[String(item.codeValue)] || "" : "";
            },

            /**
             * 校验换行是否允许，超过最大行数-1时，不允许换行
             * val：默认参数
             * content：输入内容
             * row：最大行数
             * length: 单行最大字符个数
             */
            validateKeyDown(val, content, row, length) {
                let rowArray = [];
                if (content != "") {
                    rowArray = content.split("\n");//获取单行数据
                }

                let event = window.event || arguments[0];
                // console.log(event,event.keyCode);
                if (event.key == 'Enter' || event.code == 'Enter' || event.keyCode == 13) {//回车键
                    //判断当前行数是否已达到最大行数
                    if (rowArray.length > 0) {
                        if (rowArray.length > row - 1) {//超过最大行数，则不允许换行
                            this.$message({
                                showClose: true,
                                message: val === 5 || val === 6 ?
                                    this.$t('message.charLengthLimitMsg2',
                                        {
                                            length: length,
                                            row: row
                                        }) :
                                    this.$t('message.charLengthLimitMsg',
                                        {
                                            length: length,
                                            row: row
                                        }),
                                type: 'error'
                            });
                            event.returnValue = false;
                            return false;
                        }
                    }
                }
            },

            /**
             * 订舱号输入格式化：只允许大写英文字母和数字，最大长度15位
             * @param {string} value - 输入的值
             */
            formatBkNo(value) {
                if (value === null || value === undefined) {
                    this.bookingHead.bkNo = "";
                    return;
                }

                // 转换为大写
                value = value.toUpperCase();

                // 检测是否包含不支持的字符（非大写英文字母和数字）
                const unsupportedChars = value.match(/[^A-Z0-9]/g);
                if (unsupportedChars && unsupportedChars.length > 0) {
                    // 显示提示信息
                    this.showMessage(false, "该项目仅支持输入英文字母及数字！", "warning");
                }

                // 只保留大写英文字母和数字，移除其他字符
                value = value.replace(/[^A-Z0-9]/g, '');

                // 限制长度为15位
                if (value.length > 15) {
                    value = value.substring(0, 15);
                }

                // 更新值
                this.bookingHead.bkNo = value;
            },

            /************************************ 【订舱预配箱】-新增、删除 按钮点击事件 ************************************/
            addBkPreContainer() {//订舱预配箱-【新增】按钮点击
                this.bkPreContainers.push({
                    bkPreContainerId: "",
                    containerType: "20GP",
                    quantity: "1",
                    cargoTypeCode: "0001"
                })
            },
            removeBkPreContainer(i, j) {//订舱预配箱-【删除】按钮点击：删除当前行订舱预配箱数据
                this.$confirm(this.$t("message.preContainerDeleteConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    //删除
                    if (i.bkPreContainerId !== null && i.bkPreContainerId !== "") {
                        //将该条记录加入到待删除订舱预配箱记录数组中
                        this.deleteBkPreContainers.push(this.bkPreContainers[j]);
                        this.bkPreContainers.splice(j, 1);
                    } else {
                        this.bkPreContainers.splice(j, 1);
                    }
                    // 判断是否需要清空特殊设置信息
                    if (i.cargoTypeCode === "0002") {//冻货
                        // 取消舱单冻货标志，清空冻货数据
                        this.bookingHead.rfCheckFlag = false;
                        this.bkCargo.bkReefers.forEach((reffer) => {
                            this.deleteBkReefers.push(reffer);
                        });
                        this.bkCargo.bkReefers = [];//清空冷箱信息
                    } else if (i.cargoTypeCode === "0004") {//全危
                        // 取消舱单危险品标志，清空危险品数据
                        this.bookingHead.dgCheckFlag = false;
                        this.bkCargo.bkImos.forEach((imo) => {
                            this.deleteBkImos.push(imo);
                        });
                        this.bkCargo.bkImos = [];//清空危险品信息
                    }
                })
                .catch(action => {
                    //取消
                    if (action === 'cancel') {
                        console.log(action);
                    }
                })
            },

            /************************************ 【特殊设置】-新增、删除 按钮点击事件 ************************************/
            addArray(name) {//特殊设置-【新增】按钮点击
                switch (name) {
                    case "bkImos":
                        this.bkCargo.bkImos.push({
                            bkImoId: "",
                            classType: "",
                            unSeriseNo: "",
                            label: "",
                            packageDesc: "",
                            packageCode: "",
                            property: "",
                            componentDesc: "",
                            emergencySeq: "",
                            emergencyTelNo: "",
                            quantity: "",
                            grossWeight: "",
                            netWeight: "",
                            flashPoint: "",
                            rateBase: "",
                            isPolutionFlag: ""
                        });
                        break;
                    case "bkReefers":
                        this.bkCargo.bkReefers.push({bkReeferId: "", rateBase: "", temperature: "", intakeNum: "",})
                        break;
                    case "bkAks":
                        this.bookingHead.bkAks.push({
                            bkAkId: "",
                            containerType: "",
                            akLength: "",
                            akWidth: "",
                            akHigth: "",
                            akGrossWeight: ""
                        });
                        break;
                }
            },
            removeArray(name) {//特殊设置-【删除】按钮点击
                switch (name) {
                    case "bkImos":
                        this.removeBkImo();
                        break;
                    case "bkReefers":
                        this.removeBkReefer();
                        break;
                    case "bkAks":
                        this.removeBkAk();
                        break;
                }
            },
            removeBkImo() {
                if (this.bkCargo.bkImos.length === 0) {
                    return;
                }
                let index = this.bkCargo.bkImos.length - 1;
                let bkImoId = this.bkCargo.bkImos[index].bkImoId;
                this.$confirm(this.$t("message.imoDeleteConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    //删除
                    if (bkImoId !== null && bkImoId !== "") {
                        //将该条记录加入到待删除危险品记录数组中
                        this.deleteBkImos.push(this.bkCargo.bkImos[index]);
                        this.bkCargo.bkImos.splice(index, 1);
                    } else {
                        this.bkCargo.bkImos.splice(index, 1);
                    }
                })
                .catch(action => {
                    //取消
                    if (action === 'cancel') {
                        console.log(action);
                    }
                })
            },
            removeBkReefer() {
                if (this.bkCargo.bkReefers.length === 0) {
                    return;
                }
                let index = this.bkCargo.bkReefers.length - 1;
                let bkReeferId = this.bkCargo.bkReefers[index].bkReeferId;
                this.$confirm(this.$t("message.reeferDeleteConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    //删除
                    if (bkReeferId !== null && bkReeferId !== "") {
                        //将该条记录加入到待删除冷箱记录数组中
                        this.deleteBkReefers.push(this.bkCargo.bkReefers[index]);
                        this.bkCargo.bkReefers.splice(index, 1);
                    } else {
                        this.bkCargo.bkReefers.splice(index, 1);
                    }
                })
                .catch(action => {
                    //取消
                    if (action === 'cancel') {
                        console.log(action);
                    }
                })
            },
            removeBkAk() {
                if (this.bookingHead.bkAks.length === 0) {
                    return;
                }
                let index = this.bookingHead.bkAks.length - 1;
                let bkAkId = this.bookingHead.bkAks[index].bkAkId;
                this.$confirm(this.$t("message.akDeleteConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    //删除
                    if (bkAkId !== null && bkAkId !== "") {
                        //将该条记录加入到待删除特种箱记录数组中
                        this.deleteBkAks.push(this.bookingHead.bkAks[index]);
                        this.bookingHead.bkAks.splice(index, 1);
                    } else {
                        this.bookingHead.bkAks.splice(index, 1);
                    }
                })
                .catch(action => {
                    //取消
                    if (action === 'cancel') {
                        console.log(action);
                    }
                })
            },

            /************************************ 底部按钮点击事件 ***********************************
             * 【保存草稿】按钮点击
             */
            returnSave() {
                //校验必填字段是否不为空
                if (!this.validateNull()) {
                    return;
                }
                //校验货物中毛重不能小于净重
                if (!this.validateGrossAndNetWeight()) {
                    return;
                }
                //校验订舱预配箱信息
                if (!this.validateBkPreContainer()) {
                    return;
                }

                if (this.isSaveClick) {
                    return;
                }
                this.isSaveClick = true;
                const condition = this.returnCondition();

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.saving'),        // 加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                });
                let that = this;

                this.axios({
                    method: 'post',
                    url: '/api/booking/bookingHeadAdd',
                    data: condition,
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showMessage(false, this.responseCode, "success");
                        if (response.data.object !== null) {
                            // 刷新session中的数据
                            this.refreshSessionData(response.data.object);
                            this.setFieldValue(response.data.object);
                        }
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    that.loadingtuo.close();
                    this.isSaveClick = false;
                }).catch(error => {
                    that.loadingtuo.close();
                    this.isSaveClick = false;
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },

            /**
             * 【发送船公司】按钮点击
             */
            returnSend() {
                //校验必填字段是否不为空
                if (!this.validateNull()) {
                    return;
                }
                //校验货物中毛重不能小于净重
                if (!this.validateGrossAndNetWeight()) {
                    return;
                }
                //校验订舱预配箱是否有记录及货类是否不为空
                if (!this.validateBkPreContainer()) {
                    return;
                }

                if (this.isSendClick) {
                    return;
                }
                this.isSendClick = true;
                const condition = this.returnCondition();

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.sending'),        // 加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                });
                let that = this;

                //当提单状态为提单确认状态时需要校验eta
                if (this.bookingHead.blStatus === 1||this.bookingHead.blStatus === 2) {
                    this.axios({
                        method: 'post',
                        url: '/api/booking/validateIsModifiable1',
                        data: condition,
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {//允许修改,弹出修改付费提示
                            this.$confirm(this.responseCode, this.$t("common.pleaseConfirm"), {
                                distinguishCancelAndClose: true,
                                confirmButtonText: this.$t("common.confirmButton"),
                                cancelButtonText: this.$t("common.cancelButton")
                            }).then(() => {
                                this.axios({
                                    method: 'post',
                                    url: '/api/booking/bookingHeadSend',
                                    data: condition,
                                    headers: {
                                        'Accept-language': localStorage.getItem("locale")
                                    }
                                }).then(response => {
                                    this.responseCode = response.data.backMessage;
                                    if (response.data.backCode === "200") {
                                        if (response.data.object !== null) {
                                            // 刷新session中的数据
                                            this.refreshSessionData(response.data.object);
                                            this.setFieldValue(response.data.object);
                                        }
                                        this.showMessage(false, this.responseCode + this.$t("common.backAuto"), "success");
                                        setTimeout(()=>{
                                            this.returnPage();
                                        },2000);
                                    } else {
                                        this.showMessage(false, this.responseCode, "error");
                                    }
                                    that.loadingtuo.close();
                                    this.isSendClick = false;
                                }).catch(error => {
                                    that.loadingtuo.close();
                                    if (error.data) {
                                        this.responseCode = error.data.backMessage;
                                        this.showMessage(false, this.responseCode, "error");
                                    } else {
                                        this.showMessage(false, error, "error");
                                    }
                                    this.isSendClick = false;
                                });

                            }).catch(action => {
                                //取消
                                if (action === 'cancel') {
                                    that.loadingtuo.close();
                                }
                                if (action === 'close') {
                                    that.loadingtuo.close();
                                }
                            })
                        } else {//不允许修改
                            this.showMessage(false, this.responseCode, "error");
                            that.loadingtuo.close();
                        }
                    }).catch(error => {
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                        that.loadingtuo.close();
                    });
                } else {
                    this.isSendClick = true;
                    this.axios({
                        method: 'post',
                        url: '/api/booking/bookingHeadSend',
                        data: condition,
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            if (response.data.object !== null) {
                                // 刷新session中的数据
                                this.refreshSessionData(response.data.object);
                                this.setFieldValue(response.data.object);
                            }
                            this.showMessage(false, this.responseCode + this.$t("common.backAuto"), "success");
                            setTimeout(()=>{
                                this.returnPage();
                            },2000);
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                        that.loadingtuo.close();
                        this.isSendClick = false;
                    }).catch(error => {
                        that.loadingtuo.close();
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                        this.isSendClick = false;
                    });
                }
            },
            /*/!**
             * 【发送船公司】按钮点击
             *!/
            returnSend() {
                //校验必填字段是否不为空
                if (!this.validateNull()) {
                    return;
                }
                //校验订舱预配箱是否有记录及货类是否不为空
                if (!this.validateBkPreContainer()) {
                    return;
                }

                if (this.isSendClick) {
                    return;
                }
                this.isSendClick = true;
                const condition = this.returnCondition();

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.sending'),        // 加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                });
                let that = this;

                this.axios({
                    method: 'post',
                    url: '/api/booking/bookingHeadSend',
                    data: condition,
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showMessage(false, this.responseCode, "success");
                        if (response.data.object !== null) {
                            this.setFieldValue(response.data.object);
                        }
                        this.returnPage();
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    that.loadingtuo.close();
                    this.isSendClick = false;
                }).catch(error => {
                    that.loadingtuo.close();
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.isSendClick = false;
                });
            },*/
            /**
             * 刷新session中的数据
             */
            refreshSessionData(bookingHeadInfo) {
                sessionStorage.setItem("PASSING_PARAMETERS", JSON.stringify(bookingHeadInfo));
            },
            /**
             * 【拷贝新增】按钮点击
             */
            copyNewBtnClick() {
                //当前打开的订舱信息是否已保存，未保存需先保存
                if (this.bookingHead.bookingHeadId === null || this.bookingHead.bookingHeadId === "") {
                    this.$alert(this.$t("message.pleaseSaveFirst"), this.$t("common.tips"), {
                        confirmButtonText: this.$t("common.okButton")
                    });
                    return;
                }

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.copying'),       // 加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                });
                let that = this;

                //查询最新数据
                this.axios({
                    method: 'post',
                    url: '/api/booking/bookingHeadCopyNew',
                    data: {
                        bookingHeadId: this.bookingHead.bookingHeadId
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        if (response.data.object !== null) {
                            // 刷新session中的数据
                            this.refreshSessionData(response.data.object);
                            this.setFieldValue(response.data.object);
                        }
                        this.showMessage(false, "拷贝完成", "success");
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    that.loadingtuo.close();
                }).catch(error => {
                    that.loadingtuo.close();
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 【返回】按钮点击
             */
            returnPage() {
                // this.$router.back(-1);
                window.opener = null;
                window.open("about:blank", "_top").close()
            },
            /**
             * 获取当前页面全部订舱数据 公共方法
             */
            returnCondition() {
                let condition = this.bookingHead;
                condition.bkRoutings = [];
                condition.bkCargos = [];
                condition.bkPreContainers = [];
                condition.bkCustomers = [];
                condition.bkExtends = [];
                //设置舱单扩展信息
                condition.bkExtends.push(this.bkExtend);
                //设置货物信息
                let cargo = this.bkCargo;
                // 保存/发送前，清洗货描中的制表符为单个空格，避免后端或打印时出现不可见字符问题
                if (cargo && typeof cargo.cargoDesc === 'string') {
                    cargo.cargoDesc = cargo.cargoDesc.replace(/\t/g, ' ');
                }
                if(this.deleteBkImos.length > 0){
                    this.deleteBkImos.forEach((deleteItem) => {
                        deleteItem.rowStatus = 8;//设置为待删除状态
                        cargo.bkImos.push(deleteItem);
                    })
                }
                if(this.deleteBkReefers.length > 0){
                    this.deleteBkReefers.forEach((deleteItem) => {
                        deleteItem.rowStatus = 8;//设置为待删除状态
                        cargo.bkReefers.push(deleteItem);
                    })
                }
                condition.bkCargos.push(cargo);
                //设置特种箱信息
                condition.bkAks = this.bookingHead.bkAks;
                if(this.deleteBkAks.length > 0){
                    this.deleteBkAks.forEach((deleteItem) => {
                        deleteItem.rowStatus = 8;//设置为待删除状态
                        condition.bkAks.push(deleteItem);
                    })
                }
                //设置客户信息
                //1.发货人
                let shipperCatalog = [];
                if (this.shipper.customerName !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.customerNameCatalogId,
                        sequence: 1,
                        catalogContent: this.shipper.customerName,
                        printFlag: this.shipper.customerNamePrintFlag
                    });
                }
                if (this.shipper.address !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.addressCatalogId,
                        sequence: 2,
                        catalogContent: this.shipper.address,
                        printFlag: this.shipper.addressPrintFlag
                    });
                }
                if (this.shipper.city !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.cityCatalogId,
                        sequence: 3,
                        catalogContent: this.shipper.city,
                        printFlag: this.shipper.cityPrintFlag
                    });
                }
                if (this.shipper.provinceCode !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.provinceCodeCatalogId,
                        sequence: 4,
                        catalogContent: this.shipper.provinceCode,
                        printFlag: this.shipper.provinceCodePrintFlag
                    });
                }
                if (this.shipper.provinceName !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.provinceNameCatalogId,
                        sequence: 5,
                        catalogContent: this.shipper.provinceName,
                        printFlag: this.shipper.provinceNamePrintFlag
                    });
                }
                if (this.shipper.postCode !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.postCodeCatalogId,
                        sequence: 6,
                        catalogContent: this.shipper.postCode,
                        printFlag: this.shipper.postCodePrintFlag
                    });
                }
                if (this.shipper.countryCode !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.countryCodeCatalogId,
                        sequence: 7,
                        catalogContent: this.shipper.countryCode,
                        printFlag: this.shipper.countryCodePrintFlag
                    });
                }
                if (this.shipper.tel !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.telCatalogId,
                        sequence: 8,
                        catalogContent: this.shipper.tel,
                        printFlag: this.shipper.telPrintFlag
                    });
                }
                if (this.shipper.email !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.emailCatalogId,
                        sequence: 9,
                        catalogContent: this.shipper.email,
                        printFlag: this.shipper.emailPrintFlag
                    });
                }
                if (this.shipper.enterpriseCode !== "") {
                    shipperCatalog.push({
                        bkCustomerId: this.shipper.bkCustomerId,
                        bkCustomerCatalogId: this.shipper.enterpriseCodeCatalogId,
                        sequence: 11,
                        catalogContent: this.shipper.enterpriseCode,
                        printFlag: this.shipper.enterpriseCodePrintFlag
                    });
                }
                if(this.shipper.otherCatalogs.length > 0){
                    this.shipper.otherCatalogs.forEach((item) => {
                        shipperCatalog.push(item);
                    })
                }
                if (shipperCatalog.length > 0) {
                    //拼接打单内容
                    let shipperCompanyName = "";
                    shipperCatalog.forEach((item) => {
                        if (item.printFlag) {
                            shipperCompanyName = shipperCompanyName === "" ?
                                shipperCompanyName + item.catalogContent :
                                shipperCompanyName + "\n" + item.catalogContent;
                        }
                    });
                    condition.bkCustomers.push({
                        customerType: this.shipper.customerType,
                        bkCustomerId: this.shipper.bkCustomerId,
                        bookingHeadId: this.bookingHead.bookingHeadId,
                        companyName: shipperCompanyName,
                        bkCustomerCatalogs: shipperCatalog
                    });
                }
                //2.收货人
                let consigneeCatalog = [];
                if (this.consignee.customerName !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.customerNameCatalogId,
                        sequence: 1,
                        catalogContent: this.consignee.customerName,
                        printFlag: this.consignee.customerNamePrintFlag
                    });
                }
                if (this.consignee.address !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.addressCatalogId,
                        sequence: 2,
                        catalogContent: this.consignee.address,
                        printFlag: this.consignee.addressPrintFlag
                    });
                }
                if (this.consignee.city !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.cityCatalogId,
                        sequence: 3,
                        catalogContent: this.consignee.city,
                        printFlag: this.consignee.cityPrintFlag
                    });
                }
                if (this.consignee.provinceCode !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.provinceCodeCatalogId,
                        sequence: 4,
                        catalogContent: this.consignee.provinceCode,
                        printFlag: this.consignee.provinceCodePrintFlag
                    });
                }
                if (this.consignee.provinceName !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.provinceNameCatalogId,
                        sequence: 5,
                        catalogContent: this.consignee.provinceName,
                        printFlag: this.consignee.provinceNamePrintFlag
                    });
                }
                if (this.consignee.postCode !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.postCodeCatalogId,
                        sequence: 6,
                        catalogContent: this.consignee.postCode,
                        printFlag: this.consignee.postCodePrintFlag
                    });
                }
                if (this.consignee.countryCode !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.countryCodeCatalogId,
                        sequence: 7,
                        catalogContent: this.consignee.countryCode,
                        printFlag: this.consignee.countryCodePrintFlag
                    });
                }
                if (this.consignee.tel !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.telCatalogId,
                        sequence: 8,
                        catalogContent: this.consignee.tel,
                        printFlag: this.consignee.telPrintFlag
                    });
                }
                if (this.consignee.email !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.emailCatalogId,
                        sequence: 9,
                        catalogContent: this.consignee.email,
                        printFlag: this.consignee.emailPrintFlag
                    });
                }
                if (this.consignee.enterpriseCode !== "") {
                    consigneeCatalog.push({
                        bkCustomerId: this.consignee.bkCustomerId,
                        bkCustomerCatalogId: this.consignee.enterpriseCodeCatalogId,
                        sequence: 15,
                        catalogContent: this.consignee.enterpriseCode,
                        printFlag: this.consignee.enterpriseCodePrintFlag
                    });
                }
                if(this.consignee.otherCatalogs.length > 0){
                    this.consignee.otherCatalogs.forEach((item) => {
                        consigneeCatalog.push(item);
                    })
                }
                if (consigneeCatalog.length > 0) {
                    //拼接打单内容
                    let consigneeCompanyName = "";
                    consigneeCatalog.forEach((item) => {
                        if (item.printFlag) {
                            consigneeCompanyName = consigneeCompanyName === "" ?
                                consigneeCompanyName + item.catalogContent :
                                consigneeCompanyName + "\n" + item.catalogContent;
                        }
                    });
                    condition.bkCustomers.push({
                        customerType: this.consignee.customerType,
                        bkCustomerId: this.consignee.bkCustomerId,
                        bookingHeadId: this.bookingHead.bookingHeadId,
                        companyName: consigneeCompanyName,
                        bkCustomerCatalogs: consigneeCatalog
                    });
                }
                //3.通知人1
                let notifier1Catalog = [];
                if (this.notifier1.customerName !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.customerNameCatalogId,
                        sequence: 1,
                        catalogContent: this.notifier1.customerName,
                        printFlag: this.notifier1.customerNamePrintFlag
                    });
                }
                if (this.notifier1.address !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.addressCatalogId,
                        sequence: 2,
                        catalogContent: this.notifier1.address,
                        printFlag: this.notifier1.addressPrintFlag
                    });
                }
                if (this.notifier1.city !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.cityCatalogId,
                        sequence: 3,
                        catalogContent: this.notifier1.city,
                        printFlag: this.notifier1.cityPrintFlag
                    });
                }
                if (this.notifier1.provinceCode !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.provinceCodeCatalogId,
                        sequence: 4,
                        catalogContent: this.notifier1.provinceCode,
                        printFlag: this.notifier1.provinceCodePrintFlag
                    });
                }
                if (this.notifier1.provinceName !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.provinceNameCatalogId,
                        sequence: 5,
                        catalogContent: this.notifier1.provinceName,
                        printFlag: this.notifier1.provinceNamePrintFlag
                    });
                }
                if (this.notifier1.postCode !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.postCodeCatalogId,
                        sequence: 6,
                        catalogContent: this.notifier1.postCode,
                        printFlag: this.notifier1.postCodePrintFlag
                    });
                }
                if (this.notifier1.countryCode !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.countryCodeCatalogId,
                        sequence: 7,
                        catalogContent: this.notifier1.countryCode,
                        printFlag: this.notifier1.countryCodePrintFlag
                    });
                }
                if (this.notifier1.tel !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.telCatalogId,
                        sequence: 8,
                        catalogContent: this.notifier1.tel,
                        printFlag: this.notifier1.telPrintFlag
                    });
                }
                if (this.notifier1.email !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.emailCatalogId,
                        sequence: 9,
                        catalogContent: this.notifier1.email,
                        printFlag: this.notifier1.emailPrintFlag
                    });
                }
                if (this.notifier1.enterpriseCode !== "") {
                    notifier1Catalog.push({
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bkCustomerCatalogId: this.notifier1.enterpriseCodeCatalogId,
                        sequence: 15,
                        catalogContent: this.notifier1.enterpriseCode,
                        printFlag: this.notifier1.enterpriseCodePrintFlag
                    });
                }
                if(this.notifier1.otherCatalogs.length > 0){
                    this.notifier1.otherCatalogs.forEach((item) => {
                        notifier1Catalog.push(item);
                    })
                }
                if (notifier1Catalog.length > 0) {
                    //拼接打单内容
                    let notifier1CompanyName = "";
                    notifier1Catalog.forEach((item) => {
                        if (item.printFlag) {
                            notifier1CompanyName = notifier1CompanyName === "" ?
                                notifier1CompanyName + item.catalogContent :
                                notifier1CompanyName + "\n" + item.catalogContent;
                        }
                    });
                    condition.bkCustomers.push({
                        customerType: this.notifier1.customerType,
                        bkCustomerId: this.notifier1.bkCustomerId,
                        bookingHeadId: this.bookingHead.bookingHeadId,
                        companyName: notifier1CompanyName,
                        bkCustomerCatalogs: notifier1Catalog
                    });
                }
                //4.通知人2
                let notifier2Catalog = [];
                if (this.notifier2.customerName !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.customerNameCatalogId,
                        sequence: 1,
                        catalogContent: this.notifier2.customerName,
                        printFlag: this.notifier2.customerNamePrintFlag
                    });
                }
                if (this.notifier2.address !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.addressCatalogId,
                        sequence: 2,
                        catalogContent: this.notifier2.address,
                        printFlag: this.notifier2.addressPrintFlag
                    });
                }
                if (this.notifier1.city !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.cityCatalogId,
                        sequence: 3,
                        catalogContent: this.notifier2.city,
                        printFlag: this.notifier2.cityPrintFlag
                    });
                }
                if (this.notifier2.provinceCode !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.provinceCodeCatalogId,
                        sequence: 4,
                        catalogContent: this.notifier2.provinceCode,
                        printFlag: this.notifier2.provinceCodePrintFlag
                    });
                }
                if (this.notifier2.provinceName !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.provinceNameCatalogId,
                        sequence: 5,
                        catalogContent: this.notifier2.provinceName,
                        printFlag: this.notifier2.provinceNamePrintFlag
                    });
                }
                if (this.notifier2.postCode !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.postCodeCatalogId,
                        sequence: 6,
                        catalogContent: this.notifier2.postCode,
                        printFlag: this.notifier2.postCodePrintFlag
                    });
                }
                if (this.notifier2.countryCode !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.countryCodeCatalogId,
                        sequence: 7,
                        catalogContent: this.notifier2.countryCode,
                        printFlag: this.notifier2.countryCodePrintFlag
                    });
                }
                if (this.notifier2.tel !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.telCatalogId,
                        sequence: 8,
                        catalogContent: this.notifier2.tel,
                        printFlag: this.notifier2.telPrintFlag
                    });
                }
                if (this.notifier2.email !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.emailCatalogId,
                        sequence: 9,
                        catalogContent: this.notifier2.email,
                        printFlag: this.notifier2.emailPrintFlag
                    });
                }
                if (this.notifier2.enterpriseCode !== "") {
                    notifier2Catalog.push({
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bkCustomerCatalogId: this.notifier2.enterpriseCodeCatalogId,
                        sequence: 15,
                        catalogContent: this.notifier2.enterpriseCode,
                        printFlag: this.notifier2.enterpriseCodePrintFlag
                    });
                }
                if(this.notifier2.otherCatalogs.length > 0){
                    this.notifier2.otherCatalogs.forEach((item) => {
                        notifier2Catalog.push(item);
                    })
                }
                if (notifier2Catalog.length > 0) {
                    //拼接打单内容
                    let notifier2CompanyName = "";
                    notifier2Catalog.forEach((item) => {
                        if (item.printFlag) {
                            notifier2CompanyName = notifier2CompanyName === "" ?
                                notifier2CompanyName + item.catalogContent :
                                notifier2CompanyName + "\n" + item.catalogContent;
                        }
                    });
                    condition.bkCustomers.push({
                        customerType: this.notifier2.customerType,
                        bkCustomerId: this.notifier2.bkCustomerId,
                        bookingHeadId: this.bookingHead.bookingHeadId,
                        companyName: notifier2CompanyName,
                        bkCustomerCatalogs: notifier2Catalog
                    });
                }
                //设置订舱预配箱信息
                if (this.bkPreContainers.length > 0) {
                    this.bkPreContainers.forEach((item) => {
                        if (item.containerType !== "" || item.quantity !== "" || item.cargoTypeCode !== "") {
                            condition.bkPreContainers.push(item);
                        }
                    })
                }
                if(this.deleteBkPreContainers.length > 0){
                    this.deleteBkPreContainers.forEach((deleteItem) => {
                        deleteItem.rowStatus = 8;//设置为待删除状态
                        condition.bkPreContainers.push(deleteItem);
                    })
                }
                //设置中转信息
                let tripNum = 0;
                let isD2F = false;//是否内转外舱单
                let isInternationalTransit = false;//是否国际中转
                if(this.bookingHead.transitPort != ""
                    && this.bookingHead.transitPort != this.bookingHead.pod){
                    isInternationalTransit = true;
                }
                //校验接货地与装货港是否相同=>>若不同，设置舱单中转标志为true，判断是否输入前程运输信息=>>若未输入前程运输信息，生成一条默认的前程运输信息
                if (this.bookingHead.por !== this.bookingHead.pol) {
                    this.bookingHead.tsFlag = true;
                    //设置前程运输信息
                    this.bkRoutingPre.tripNumber = ++tripNum;
                    this.bkRoutingPre.portFrom = this.bookingHead.por;
                    this.bkRoutingPre.portTo = this.bookingHead.pol;
                    this.bkRoutingPre.bookingStatus = 1;        //支线运输信息订舱状态默认为订舱确认状态
                    if (this.bkRoutingPre.voyageNo === null || this.bkRoutingPre.voyageNo === "") {
                        this.bkRoutingPre.voyageNo = "T/S"; //航次未填写时默认为T/S
                    }
                    if(this.bkRoutingPre.outTransportType === null || this.bkRoutingPre.outTransportType === ""){
                        this.bkRoutingPre.outTransportType = 0; //出口运输类型未填写时默认为本港
                    }
                    if(this.bkRoutingPre.inTransportType === null || this.bkRoutingPre.inTransportType === ""){
                        this.bkRoutingPre.inTransportType = 0;      //进口运输类型未填写时默认为本港
                    }
                    if(this.bkRoutingPre.serviceLineCode === null || this.bkRoutingPre.serviceLineCode === ""){
                        this.bkRoutingPre.serviceLineCode = "T/S";  //航线未填写时默认为T/S
                    }
                    if(this.bkRoutingPre.vesselName === null || this.bkRoutingPre.vesselName === ""){
                        this.bkRoutingPre.vesselName = "T/S";       //船名称未填写时默认为T/S
                    }
                    if (this.bkRoutingPre.vesselCode === null || this.bkRoutingPre.vesselCode === "") {  //船名未填写时默认为T/S
                        this.bkRoutingPre.vesselCode = "T/S";
                    }
                    if (this.bkRoutingPre.carrier === null || this.bkRoutingPre.carrier === "") {     //承运人未填写时根据登录主体设置
                        this.bkRoutingPre.carrier = this.getCarrierByEntity();
                    }
                    //判断是否为内转外舱单
                    if(this.bkRoutingPre.carrier === "ZGI"){
                        isD2F = true;
                        this.bkRoutingPre.serviceLineCode = "DT/S";  //航线默认为DT/S,内转外航线
                        if(this.bkRoutingPre.voyageNo === "T/S"){
                            this.bkRoutingPre.voyageNo = "DT/S";    //若选择航次未T/S,自动设置为DT/S
                        }
                    }else {
                        this.bkRoutingPre.serviceLineCode = "T/S";  //航线默认为T/S,中转航线
                        if(this.bkRoutingPre.voyageNo === "DT/S"){
                            this.bkRoutingPre.voyageNo = "T/S";    //若选择航次未DT/S,自动调整为T/S
                        }
                    }
                    this.bkRoutingPre.voyageNo = this.bkRoutingPre.voyageNo.toUpperCase();
                    this.bkRoutingPre.carrier = this.bkRoutingPre.carrier.toUpperCase();
                    condition.bkRoutings.push(this.bkRoutingPre);
                }

                //赋值干线运输信息船期相关字段
                this.bkRouting1.vesselCode = this.bookingHead.vesselCode;
                this.bkRouting1.vesselName = this.bookingHead.vesselName;
                this.bkRouting1.voyageNo = this.bookingHead.voyageNo;
                this.bkRouting1.voyageLeg = this.bookingHead.voyageLeg;
                this.bkRouting1.voyagePlanId = this.bookingHead.voyagePlanId;
                this.bkRouting1.serviceLineCode = this.bookingHead.serviceLineCode;
                this.bkRouting1.tripNumber = ++tripNum;
                if(isD2F){
                    //内转外运输类型赋值为内转外
                    this.bkRouting1.outTransportType = 9;
                    //提单运输类型设置为内转外
                    condition.transportType = 9;
                }/*else{
                    //内转外运输类型赋值为本港
                    this.bkRouting1.outTransportType = 0;
                    //提单运输类型设置为本港
                    condition.transportType = 0;
                }*/
                // 一程干线起始港设置为舱单装货港
                this.bkRouting1.portFrom = this.bookingHead.pol;
                if(isInternationalTransit){
                    //如果存在国际中转，一程干线抵达港设置为接舱卸货港，即国际中转港
                    this.bkRouting1.portTo = this.bookingHead.transitPort;
                }else{
                    //不存在国际中转，抵达港即为舱单卸货港
                    this.bkRouting1.portTo = this.bookingHead.pod;
                }
                condition.bkRoutings.push(this.bkRouting1);

                //如果存在国际中转，则再增加一程干线
                if(isInternationalTransit){
                    //二程干线起始港设置为接舱卸货港，即为国际中转港
                    this.bkRoutingTransit.portFrom = this.bookingHead.transitPort;
                    //二程干线抵达港设置为舱单卸货港
                    this.bkRoutingTransit.portTo = this.bookingHead.pod;
                    if(this.bkRoutingTransit.outTransportType == null
                        || this.bkRoutingTransit.outTransportType == ""){
                        //出口运输类型设置为国际中转
                        this.bkRoutingTransit.outTransportType = 1;
                    }
                    if(this.bkRoutingTransit.inTransportType == null
                        || this.bkRoutingTransit.inTransportType == ""){
                        //进口运输类型默认为本港
                        this.bkRoutingTransit.inTransportType = 0;
                    }
                    if(this.bkRoutingTransit.vesselCode == null
                        || this.bkRoutingTransit.vesselCode == ""){
                        this.bkRoutingTransit.vesselCode = "TBA";
                    }
                    if(this.bkRoutingTransit.vesselName == null
                        || this.bkRoutingTransit.vesselName == ""){
                        this.bkRoutingTransit.vesselName = "TBA";
                    }
                    if(this.bkRoutingTransit.voyageNo == null
                        || this.bkRoutingTransit.voyageNo == ""){
                        this.bkRoutingTransit.voyageNo = "TBA";
                    }
                    if(this.bkRoutingTransit.voyageLeg == null
                        || this.bkRoutingTransit.voyageLeg == ""){
                        this.bkRoutingTransit.voyageLeg = "TBA";
                    }
                    if(this.bkRoutingTransit.carrier == null
                        || this.bkRoutingTransit.carrier == ""){
                        this.bkRoutingTransit.carrier = this.getCarrierByEntity();
                    }
                    if(this.bkRoutingTransit.serviceLineCode == null
                        || this.bkRoutingTransit.serviceLineCode == ""){
                        this.bkRoutingTransit.serviceLineCode = "T/S";
                    }
                    if(this.bkRoutingTransit.bookingStatus == null){
                        this.bkRoutingTransit.bookingStatus = 0;
                    }
                    this.bkRoutingTransit.lineType = 1;
                    this.bkRoutingTransit.tripNumber = ++tripNum;
                    if(this.bkRoutingTransit.isNoticedFlag == null){
                        this.bkRoutingTransit.isNoticedFlag = false;
                    }
                    this.bookingHead.tsFlag = true;
                    this.bookingHead.transportType = 1;
                    condition.bkRoutings.push(this.bkRoutingTransit);
                }

                //校验卸货港与目的地是否相同=>>若不同，设置舱单中转标志为true，生成一条默认的后程运输信息
                if (this.bookingHead.del !== this.bookingHead.pod) {
                    this.bookingHead.tsFlag = true;
                    //生成默认的后程运输信息
                    this.bkRoutingNext.tripNumber = ++tripNum;
                    this.bkRoutingNext.portFrom = this.bookingHead.pod;
                    this.bkRoutingNext.portTo = this.bookingHead.del;
                    this.bkRoutingNext.bookingStatus = 1;       //支线运输信息订舱状态默认为订舱确认状态
                    if (this.bkRoutingNext.outTransportType === null || this.bkRoutingNext.outTransportType === "") {
                        this.bkRoutingNext.outTransportType = 0;//出口运输类型为空则默认为本港
                    }
                    if (this.bkRoutingNext.inTransportType === null || this.bkRoutingNext.inTransportType === "") {
                        this.bkRoutingNext.inTransportType = 0;//进口运输类型为空默认为本港
                    }
                    if (this.bkRoutingNext.serviceLineCode === null || this.bkRoutingNext.serviceLineCode === "") {
                        this.bkRoutingNext.serviceLineCode = "T/S";
                    }
                    if (this.bkRoutingNext.vesselName === null || this.bkRoutingNext.vesselName === "") {
                        this.bkRoutingNext.vesselName = "T/S";
                    }
                    if (this.bkRoutingNext.vesselCode === null || this.bkRoutingNext.vesselCode === "") {
                        this.bkRoutingNext.vesselCode = "T/S";
                    }
                    if (this.bkRoutingNext.voyageNo === null || this.bkRoutingNext.voyageNo === "") {
                        this.bkRoutingNext.voyageNo = "T/S";
                    }
                    this.bkRoutingNext.carrier = this.getCarrierByEntity();         //承运人根据登录主体设置
                    condition.bkRoutings.push(this.bkRoutingNext);
                }
                return condition;
            },
            getCompanyName(customerCatalogs) {
                let companyName = "";
                if (customerCatalogs.length > 0) {
                    customerCatalogs.forEach((item) => {
                        if (item.printFlag) {
                            companyName = companyName === "" ?
                                item.catalogContent :
                                companyName + "\n" + item.catalogContent;
                        }
                    });
                    return companyName;
                }
            },

            /************************************ 保存、发送前校验 ***********************************
             * 校验必填字段是否非空
             */
            validateNull() {
                //订舱号
                if (this.bookingHead.bkNo === "") {
                    this.showMessage(false, this.$t("message.bkNoNotNull"), "error");
                    return false;
                }
                // //接货地
                // if (this.bookingHead.por === "") {
                //     this.showMessage(false, this.$t("message.porNotNull"), "error");
                //     return false;
                // }
                //目的地
                if (this.bookingHead.del === "") {
                    this.showMessage(false, this.$t("message.delNotNull"), "error");
                    return false;
                }
                //运输条款
                if (this.bookingHead.transportationTerms === "") {
                    this.showMessage(false, this.$t("message.transportationTermsNotNull"), "error");
                    return false;
                }
                //付费方式
                if (this.bookingHead.paidType === "") {
                    this.showMessage(false, this.$t("message.paidTypeNotNull"), "error");
                    return false;
                }
                //询价单位
                if (this.bkExtend.applicantUnit === "") {
                    this.showMessage(false, this.$t("message.applicationUnitNotNull"), "error");
                    return false;
                } else {
                    // 获取当前询价单位填写内容的长度
                    let applicantUnitLength = this.getApplicantUnitLength(this.bkExtend.applicantUnit);
                    if (applicantUnitLength > 20) {
                        this.showMessage(false, this.$t('message.applicationUnitLengthWarn',{charLength: applicantUnitLength}), "error");
                        return false;
                    }
                }
                //提单类型
                if (this.bookingHead.deliveryDocumentMethod === "") {
                    this.showMessage(false, this.$t("message.deliveryDocumentMethodNotNull"), "error");
                    return false;
                }
                //签单地点
                if (this.bookingHead.deliveryDocumentPlace === "") {
                    this.showMessage(false, this.$t("message.deliveryDocumentPlaceNotNull"), "error");
                    return false;
                }
                // //针对海防的提单，收货人及通知人的联系电话必填
                // if (this.bookingHead.pod === "VNHPH") {
                //     // 如果填写了收货人信息，收货人联系电话不能为空
                //     if (this.consignee.customerName && this.consignee.customerName.trim() !== "") {
                //         if (!this.consignee.tel || this.consignee.tel.trim() === "") {
                //             this.showMessage(false, this.$t("message.consigneeAndNotifierTelNotNull"), "error");
                //             return false;
                //         }
                //     }
                //
                //     // 如果填写了通知人1信息，通知人1联系电话不能为空
                //     if (this.notifier1.customerName && this.notifier1.customerName.trim() !== "") {
                //         if (!this.notifier1.tel || this.notifier1.tel.trim() === "") {
                //             this.showMessage(false, this.$t("message.consigneeAndNotifierTelNotNull"), "error");
                //             return false;
                //         }
                //     }
                //
                //     // 如果填写了通知人2信息，通知人2联系电话不能为空
                //     if (this.notifier2.customerName && this.notifier2.customerName.trim() !== "") {
                //         if (!this.notifier2.tel || this.notifier2.tel.trim() === "") {
                //             this.showMessage(false, this.$t("message.consigneeAndNotifierTelNotNull"), "error");
                //             return false;
                //         }
                //     }
                // }
                // 危险品非空校验
                let errorMsg = [];
                if (this.bookingHead.dgCheckFlag && this.bkCargo.bkImos.length > 0) {
                    this.bkCargo.bkImos.forEach((item, index) => {
                        // IMO Class必填
                        if (item.classType === null || item.classType === "") {
                            errorMsg.push(this.$t("message.classTypeNotNull", {index: index + 1}));
                        }
                        // UN No.必填
                        if (item.unSeriseNo === null || item.unSeriseNo === "") {
                            errorMsg.push(this.$t("message.unSeriseNoNotNull", {index: index + 1}));
                        }
                        // 包装种类必填
                        if (item.packageDesc === null || item.packageDesc === "") {
                            errorMsg.push(this.$t("message.packageDescNotNull", {index: index + 1}));
                        }
                        // 包装类型必填
                        if (item.packageCode === null || item.packageCode === "") {
                            errorMsg.push(this.$t("message.packageCodeNotNull", {index: index + 1}));
                        }
                        // 运输品名必填
                        if (item.property === null || item.property === "") {
                            errorMsg.push(this.$t("message.propertyNotNull", {index: index + 1}));
                        }
                        // 化学品名必填
                        if (item.componentDesc === null || item.componentDesc === "") {
                            errorMsg.push(this.$t("message.componentDescNotNull", {index: index + 1}));
                        }
                        // 应急措施编号必填
                        if (item.emergencySeq === null || item.emergencySeq === "") {
                            errorMsg.push(this.$t("message.emergencySeqNotNull", {index: index + 1}));
                        }
                    });
                }
                // 冷箱非空校验
                if (this.bookingHead.rfCheckFlag && this.bkCargo.bkReefers.length > 0) {
                    this.bkCargo.bkReefers.forEach((item, index) => {
                        // 单位必填
                        if (item.rateBase === null || item.rateBase === "") {
                            errorMsg.push(this.$t("message.rateBaseNotNull", {index: index + 1}));
                        }
                        // 温度必填
                        if (item.temperature === null || item.temperature === "") {
                            errorMsg.push(this.$t("message.temperatureNotNull", {index: index + 1}));
                        }
                        // 通风口必填
                        if (item.intakeNum === null || item.intakeNum === "") {
                            errorMsg.push(this.$t("message.intakeNumNotNull", {index: index + 1}));
                        }
                    });
                }
                if (errorMsg.length > 0) {
                    this.$message({
                                      dangerouslyUseHTMLString: true,
                                      message: errorMsg.join(' <br/><br/> '),
                                      type: 'error'
                                  });
                    return false;
                }

                return true;
            },
            /**
             * 获取询价单位长度
             * @param {string} value - 输入的值
             * @returns {boolean} - 是否通过验证
             */
            getApplicantUnitLength(value) {
                if (value == null || value.length <= 0)
                    return true;

                let length = 0;
                for (let i = 0; i < value.length; i++) {
                    // 使用正则判断是否为中文字符
                    if (/[\u4e00-\u9fa5]/.test(value[i])) {
                        length += 2;
                    } else {
                        length += 1;
                    }
                }
                return length;
            },
            /*
             * 校验货物信息中毛重不能小于净重
             */
            validateGrossAndNetWeight() {
                // 获取毛重
                const grossWeight = parseFloat(this.bkCargo.grossWeight);
                // 获取净重
                const netWeight = parseFloat(this.bkCargo.netWeight);

                // 只有当毛重和净重都有值时才进行校验
                if (!isNaN(grossWeight) && !isNaN(netWeight)) {
                    if (grossWeight < netWeight) {
                        this.showMessage(false, this.$t("message.grossWeightLessThanNetWeight"), "error");
                        return false;
                    }
                }
                return true;
            },
            /**
             * 订舱预配箱信息校验
             */
            validateBkPreContainer() {
                let dgFlag = false;
                let rfFlag = false;
                let isEmpty = false;
                //校验是否有订舱预配箱记录
                if (this.bkPreContainers.length <= 0) {
                    this.showMessage(false, this.$t("message.noBkPreContainer"), "error");
                    return false;
                }

                this.bkPreContainers.forEach((item, index) => {
                    if (item.cargoTypeCode === "") {
                        this.showMessage(false, this.$t("message.noCargoTypeCode", {index: index}), "error");
                        return false;
                    }
                    //判断订舱预配箱信息中是否包含货类为全危或冻货的信息
                    if (item.cargoTypeCode === "0004") {
                        dgFlag = true;
                    }
                    if (item.cargoTypeCode === "0002") {
                        rfFlag = true;
                    }
                    //判断是否为重箱
                    if (item.cargoTypeCode === "0014" || item.cargoTypeCode === "0018") {
                        isEmpty = true;
                    }
                });

                //当订舱预配箱信息中存在货类为全危或冻货的信息时，校验是否添加了危险品/冷箱信息
                if (dgFlag && this.bkCargo.bkImos.length <= 0) {
                    this.showMessage(false, this.$t("message.addDgInfoMsg"), "error");
                    return false;
                }
                if (rfFlag && this.bkCargo.bkReefers.length <= 0) {
                    this.showMessage(false, this.$t("message.addRfInfoMsg"), "error");
                    return false;
                }
                // add by liyan 2022/11/2 下货纸里货类除了空箱、商品空箱外 HSCODE必填
                if (!isEmpty && (this.bookingHead.hsCode == null
                        || this.bookingHead.hsCode === "")) {
                    this.showMessage(false, this.$t("message.hsCodeNotNull"), "error");
                    return false;
                }
                return true;
            },

            /************************************ 危险品/冷箱输入保存校验 ***********************************
             * A.当订舱预配箱中存在货类为全危或冻货的记录时，特殊设置中对应危险品或冷箱复选框自动勾选，
             *   此时必须录入危险品或冷箱数据，在保存草稿及保存并发送船公司功能中增加危险品、冷箱信息录入校验，未录入数据时给出提示；
             * B.当订舱预配箱中不存在货类为全危或冻货的记录时，特殊设置中的危险品和冷箱复选框不允许勾选，
             *   取消勾选之前判断若存在数据，需先把数据记录清空
             */
            validateCargoTypeCode(value, index) {
                let rfFlag = false;
                let dgFlag = false;
                //校验是否选中货类为危险品或冷箱
                this.bkPreContainers.forEach((item) => {
                    if (item.cargoTypeCode === "0002") {//冻货
                        rfFlag = true;
                    } else if (item.cargoTypeCode === "0004") {//全危
                        dgFlag = true;
                    }
                });
                //自动设置危险品/冷箱复选框勾选状态
                if (!dgFlag && this.bkCargo.bkImos.length > 0) {//取消勾选时需判断原有的危险品信息是否清空
                    this.bkPreContainers[index].cargoTypeCode = "0004";
                    this.showMessage(false, this.$t("message.clearDgInfo"), "error");
                } else if (!rfFlag && this.bkCargo.bkReefers.length > 0) {//取消勾选时需判断原有的冷箱信息是否清空
                    this.bkPreContainers[index].cargoTypeCode = "0002";
                    this.showMessage(false, this.$t("message.clearRfInfo"), "error");
                } else {
                    // 校验当前特殊设置是否为只读状态，只读状态下不可修改
                    if(this.getReadOnlyFlag){
                        this.showMessage(false, this.$t("message.specialLocked"), "error");
                        this.bkPreContainers[index].cargoTypeCode = "";
                    }else{
                        this.bookingHead.dgCheckFlag = dgFlag;
                        this.bookingHead.rfCheckFlag = rfFlag;
                    }
                }
            },
            /**
             * 复选框选中状态监听：货类为全危/冻货时，危险品/冷箱选中状态不可改变
             */
            validatePreInfo(event, type) {
                // console.log(event);
                //校验是否录入了货类为全危的订舱预配箱信息
                if (type === 1) {
                    //获取点击之前复选框的勾选状态
                    let checked = this.bookingHead.dgCheckFlag;
                    try {
                        //根据订舱预配箱中录入的数据判断复选框是否要勾选
                        this.bookingHead.dgCheckFlag = false;
                        this.bkPreContainers.forEach((item) => {
                            if (item.cargoTypeCode === "0004") {
                                throw new Error("EndForEach");
                            }
                        });
                    } catch (e) {
                        if (e.message !== "EndForEach") {
                            this.showMessage(false, e, "error");
                        } else {
                            //存在货类为全危的订舱预配箱数据，设置危险品复选框为选中状态
                            this.bookingHead.dgCheckFlag = true;
                        }
                    }
                    //若点击之后不符合要求，需给出提示
                    if (this.bookingHead.dgCheckFlag === checked) {
                        this.showMessage(false,
                            checked ? this.$t("message.addDgInfoMsg")
                                : this.$t("message.addDgPreContainerInfoMsg"),
                            "warning");
                        event.returnValue = false;
                        return false;
                    }
                }
                //校验是否录入了货类为冻货的订舱预配箱信息
                if (type === 2) {
                    //获取点击之前复选框的勾选状态
                    let checked = this.bookingHead.rfCheckFlag;
                    try {
                        //根据订舱预配箱中录入的数据判断复选框是否要勾选
                        this.bookingHead.rfCheckFlag = false;
                        this.bkPreContainers.forEach((item) => {
                            if (item.cargoTypeCode === "0002") {
                                throw new Error("EndForEach");
                            }
                        });
                    } catch (e) {
                        if (e.message !== "EndForEach") {
                            this.showMessage(false, e, "error");
                        } else {
                            //存在货类为冻货的订舱预配箱数据，设置冷箱复选框为选中状态
                            this.bookingHead.rfCheckFlag = true;
                        }
                    }
                    //若点击之后不符合要求，需给出提示
                    if (this.bookingHead.rfCheckFlag === checked) {
                        this.showMessage(false,
                            checked ? this.$t("message.addRfInfoMsg")
                                : this.$t("message.addRfPreContainerInfoMsg"),
                            "warning");
                        event.returnValue = false;
                        return false;
                    }
                }
            },

            /************************************ 基础数据下拉赋值 **********************************
             * 页面显示值语言切换
             */
            getDisplayValue(item) {
                return localStorage.getItem('locale') == 'en' ? item.displayValue : item.displayValueCn;
            },
            /*
             * 订舱状态
             */
            bookingStatusFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getBookingStatusList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.bookingStatusOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 订舱类型
             */
            bookingTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getBookingTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.bookingTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 提单类型
             */
            blTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getBlTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.blTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 运输条款
             */
            transportationTermsFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getServiceModeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.transportationTermsOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 付费方式
             */
            paidTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getPaidTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.paidTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 港口
             */
            portFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/port/getAllPortList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.portOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 承运人
             */
            carrierFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getCarrierList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.carrierOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 货类
             */
            cargoTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getCargoTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.cargoTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 箱型
             */
            containerTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getContainerTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.containerTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 闪点单位
             */
            rateBaseFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getFlashPointRateBaseList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.rateBaseOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 危险品-包装种类
             */
            dgPackageGroupFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getDgPackagingGroupList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.dgPackageGroupOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },

            /************************************ 货物包装类型弹出框 ***********************************
             * 弹框关闭按钮点击
             */
            closePopoverView() {
                this.$refs.packageTypePopover.showPopper = false;
            },
            /**
             * 弹框搜索按钮点击
             */
            packageTypeSearch() {
                if (this.isPopSearchClick) {
                    return;
                }
                this.isPopSearchClick = true;
                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),     // 加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    target: document.querySelector(".packageTypePopover") // 设置加载动画区域
                });
                let that = this;
                this.axios({
                    method: 'post',
                    url: '/api/codedict/getPackageTypeList',
                    data: {
                        packageType: this.popover.packageType,
                        packageDesc: this.popover.packageDesc,
                        pageNum: this.popover.popPageNum,
                        pageSize: this.popover.popPageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    that.loadingtuo.close();
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.packageTypedata = response.data.object.list;
                        this.popover.popTotal = response.data.object.total;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    this.isPopSearchClick = false;
                }).catch(error => {
                    that.loadingtuo.close();
                    this.isPopSearchClick = false;
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            popHandleDemand() {
                this.packageTypeSearch();
            },
            /**
             * 包装类型弹框记录点击事件
             */
            popRowClick(row) {
                this.popover.popTableSelection = [row];
            },
            /**
             * 弹框确认按钮点击
             */
            popConfirm() {
                if (this.popover.popTableSelection.length !== 0) {//获取弹框中最后选中的记录
                    let row = this.popover.popTableSelection[0];
                    this.bkCargo.packageType = row.codeValue;
                    this.bkCargo.packageDesc = row.displayValue;
                }
                this.$refs.packageTypePopover.showPopper = false;
                this.popover.packageType = "";
                this.popover.packageDesc = "";
            },
            /**
             * 弹框分页栏改变事件
             */
            popHandleSizeChange(val) {
                this.popover.popPageNum = 1;
                this.popover.popPageSize = val;
                this.popHandleDemand();
                this.$emit("backTop");
            },
            popHandleCurrentChange(val) {
                this.popover.popPageNum = val;
                this.popHandleDemand();
                this.$emit("backTop");
            },

            /************************************ 页面数据初始化 ***********************************
             * 获取路由携带的船期数据,设置船期相关信息
             */
            initPageInfo() {
                // if (this.$route.params == null) {
                //     return;
                // }
                // if (this.$route.params.bookingHeadInfo == null) {
                //     return;
                // }
                //
                // let bookingHeadInfo = this.$route.params.bookingHeadInfo;
                if(sessionStorage.getItem("PASSING_PARAMETERS") == null){
                    return;
                }
                let bookingHeadInfo = JSON.parse(sessionStorage.getItem("PASSING_PARAMETERS"));
                this.setFieldValue(bookingHeadInfo);
                // 初始化carrier值
                if (!this.bkRouting1.carrier || this.bkRouting1.carrier === "") {
                    this.bkRouting1.carrier = this.getCarrierByEntity();
                }
                
                // 初始化打印标志
                if(this.shipper.customerNamePrintFlag == null){
                    this.shipper.customerNamePrintFlag = true;
                }
                if(this.consignee.customerNamePrintFlag == null){
                    this.consignee.customerNamePrintFlag = true;
                }
                if(this.notifier1.customerNamePrintFlag == null){
                    this.notifier1.customerNamePrintFlag = true;
                }
                if(this.notifier2.customerNamePrintFlag == null){
                    this.notifier2.customerNamePrintFlag = true;
                }

                // 初始化询价单位
                if(sessionStorage.getItem("CUSTOMER") != null){
                    let custC= JSON.parse (sessionStorage.getItem("CUSTOMER"));
                    this.bkExtend.applicantUnit = custC.companyCode;
                }
            },
            setFieldValue(bookingHeadInfo) {
                // 清空待删除数据集合
                this.deleteBkImos = [];
                this.deleteBkReefers = [];
                this.deleteBkAks = [];
                this.deleteBkContainers = [];
                this.deleteBkPreContainers = [];

                this.bookingHead = bookingHeadInfo;
                if (bookingHeadInfo.bookingStatus || bookingHeadInfo.bookingStatus === 0) {
                    this.bookingHead.bookingStatus = bookingHeadInfo.bookingStatus.toString();
                }
                if (bookingHeadInfo.bookingType || bookingHeadInfo.bookingType === 0) {
                    this.bookingHead.bookingType = bookingHeadInfo.bookingType.toString();
                }
                if (bookingHeadInfo.paidType || bookingHeadInfo.paidType === 0) {
                    this.bookingHead.paidType = bookingHeadInfo.paidType.toString();
                }
                //【赋值舱单扩展信息】
                let bkExtends = bookingHeadInfo.bkExtends;
                if (bkExtends.length > 0) {
                    this.bkExtend = bkExtends[0];
                }
                //【赋值货物信息】
                let bkCargos = bookingHeadInfo.bkCargos;
                if (bkCargos.length > 0) {
                    this.bkCargo = bkCargos[0];
                }
                //【赋值特种箱信息】
                this.bkAks = bookingHeadInfo.bkAks;
                //【赋值中转信息】
                if (bookingHeadInfo.bkRoutings.length > 0) {
                    let bkRoutings = bookingHeadInfo.bkRoutings;
                    bkRoutings.forEach((item) => {
                        if (item.lineType === 1) {
                            if(item.portFrom === this.bookingHead.pol){
                                //赋值一程干线信息
                                this.bkRouting1 = item;
                                this.bookingHead.transitPort = item.portTo;
                            }else{
                                //赋值二程干线信息
                                this.bkRoutingTransit = item;
                            }
                        } else {
                            if (item.tripNumber === 1) {
                                //赋值前程运输信息
                                this.bkRoutingPre = item;
                            } else {
                                //赋值后程运输信息
                                this.bkRoutingNext = item;
                            }
                        }
                    })
                }
                //【赋值订舱预配箱信息】
                this.bkPreContainers = bookingHeadInfo.bkPreContainers;
                //【赋值客户信息】
                let bkCustomers = bookingHeadInfo.bkCustomers;
                if (bkCustomers.length > 0) {
                    bkCustomers.forEach((item) => {
                        if (item.customerType === 0) {
                            //【发货人信息】
                            this.shipper.customerType = item.customerType;
                            this.shipper.bkCustomerId = item.bkCustomerId;
                            item.bkCustomerCatalogs.forEach((item) => {
                                if (item.sequence == 1) {
                                    this.shipper.customerName = item.catalogContent;
                                    this.shipper.customerNameCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.customerNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 2) {
                                    this.shipper.address = item.catalogContent;
                                    this.shipper.addressCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.addressPrintFlag = item.printFlag;
                                }else if (item.sequence == 3) {
                                    this.shipper.city = item.catalogContent;
                                    this.shipper.cityCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.cityPrintFlag = item.printFlag;
                                }else if (item.sequence == 4) {
                                    this.shipper.provinceCode = item.catalogContent;
                                    this.shipper.provinceCodeCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.provinceCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 5) {
                                    this.shipper.provinceName = item.catalogContent;
                                    this.shipper.provinceNameCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.provinceNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 6) {
                                    this.shipper.postCode = item.catalogContent;
                                    this.shipper.postCodeCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.postCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 7) {
                                    this.shipper.countryCode = item.catalogContent;
                                    this.shipper.countryCodeCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.countryCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 8) {
                                    this.shipper.tel = item.catalogContent;
                                    this.shipper.telCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.telPrintFlag = item.printFlag;
                                }else if (item.sequence == 9) {
                                    this.shipper.email = item.catalogContent;
                                    this.shipper.emailCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.emailPrintFlag = item.printFlag;
                                }else if (item.sequence == 11) {
                                    this.shipper.enterpriseCode = item.catalogContent;
                                    this.shipper.enterpriseCodeCatalogId = item.bkCustomerCatalogId;
                                    this.shipper.enterpriseCodePrintFlag = item.printFlag;
                                } else{
                                    this.shipper.otherCatalogs.push(item);
                                }
                            })
                        } else if (item.customerType === 1) {
                            //【收货人信息】
                            this.consignee.customerType = item.customerType;
                            this.consignee.bkCustomerId = item.bkCustomerId;
                            item.bkCustomerCatalogs.forEach((item) => {
                                if (item.sequence == 1) {
                                    this.consignee.customerName = item.catalogContent;
                                    this.consignee.customerNameCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.customerNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 2) {
                                    this.consignee.address = item.catalogContent;
                                    this.consignee.addressCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.addressPrintFlag = item.printFlag;
                                }else if (item.sequence == 3) {
                                    this.consignee.city = item.catalogContent;
                                    this.consignee.cityCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.cityPrintFlag = item.printFlag;
                                }else if (item.sequence == 4) {
                                    this.consignee.provinceCode = item.catalogContent;
                                    this.consignee.provinceCodeCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.provinceCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 5) {
                                    this.consignee.provinceName = item.catalogContent;
                                    this.consignee.provinceNameCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.provinceNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 6) {
                                    this.consignee.postCode = item.catalogContent;
                                    this.consignee.postCodeCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.postCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 7) {
                                    this.consignee.countryCode = item.catalogContent;
                                    this.consignee.countryCodeCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.countryCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 8) {
                                    this.consignee.tel = item.catalogContent;
                                    this.consignee.telCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.telPrintFlag = item.printFlag;
                                }else if (item.sequence == 9) {
                                    this.consignee.email = item.catalogContent;
                                    this.consignee.emailCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.emailPrintFlag = item.printFlag;
                                }else if (item.sequence == 15) {
                                    this.consignee.enterpriseCode = item.catalogContent;
                                    this.consignee.enterpriseCodeCatalogId = item.bkCustomerCatalogId;
                                    this.consignee.enterpriseCodePrintFlag = item.printFlag;
                                }else{
                                    this.consignee.otherCatalogs.push(item);
                                }
                            })
                        } else if (item.customerType === 2) {
                            //【通知人1信息】
                            this.notifier1.customerType = item.customerType;
                            this.notifier1.bkCustomerId = item.bkCustomerId;
                            item.bkCustomerCatalogs.forEach((item) => {
                                if (item.sequence == 1) {
                                    this.notifier1.customerName = item.catalogContent;
                                    this.notifier1.customerNameCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.customerNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 2) {
                                    this.notifier1.address = item.catalogContent;
                                    this.notifier1.addressCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.addressPrintFlag = item.printFlag;
                                }else if (item.sequence == 3) {
                                    this.notifier1.city = item.catalogContent;
                                    this.notifier1.cityCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.cityPrintFlag = item.printFlag;
                                }else if (item.sequence == 4) {
                                    this.notifier1.provinceCode = item.catalogContent;
                                    this.notifier1.provinceCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.provinceCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 5) {
                                    this.notifier1.provinceName = item.catalogContent;
                                    this.notifier1.provinceNameCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.provinceNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 6) {
                                    this.notifier1.postCode = item.catalogContent;
                                    this.notifier1.postCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.postCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 7) {
                                    this.notifier1.countryCode = item.catalogContent;
                                    this.notifier1.countryCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.countryCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 8) {
                                    this.notifier1.tel = item.catalogContent;
                                    this.notifier1.telCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.telPrintFlag = item.printFlag;
                                }else if (item.sequence == 9) {
                                    this.notifier1.email = item.catalogContent;
                                    this.notifier1.emailCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.emailPrintFlag = item.printFlag;
                                }else if (item.sequence == 15) {
                                    this.notifier1.enterpriseCode = item.catalogContent;
                                    this.notifier1.enterpriseCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier1.enterpriseCodePrintFlag = item.printFlag;
                                }else{
                                    this.notifier1.otherCatalogs.push(item);
                                }
                            })
                        } else {
                            //【通知人2信息】
                            this.notifier2.customerType = item.customerType;
                            this.notifier2.bkCustomerId = item.bkCustomerId;
                            item.bkCustomerCatalogs.forEach((item) => {
                                if (item.sequence == 1) {
                                    this.notifier2.customerName = item.catalogContent;
                                    this.notifier2.customerNameCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.customerNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 2) {
                                    this.notifier2.address = item.catalogContent;
                                    this.notifier2.addressCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.addressPrintFlag = item.printFlag;
                                }else if (item.sequence == 3) {
                                    this.notifier2.city = item.catalogContent;
                                    this.notifier2.cityCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.cityPrintFlag = item.printFlag;
                                }else if (item.sequence == 4) {
                                    this.notifier2.provinceCode = item.catalogContent;
                                    this.notifier2.provinceCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.provinceCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 5) {
                                    this.notifier2.provinceName = item.catalogContent;
                                    this.notifier2.provinceNameCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.provinceNamePrintFlag = item.printFlag;
                                }else if (item.sequence == 6) {
                                    this.notifier2.postCode = item.catalogContent;
                                    this.notifier2.postCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.postCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 7) {
                                    this.notifier2.countryCode = item.catalogContent;
                                    this.notifier2.countryCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.countryCodePrintFlag = item.printFlag;
                                }else if (item.sequence == 8) {
                                    this.notifier2.tel = item.catalogContent;
                                    this.notifier2.telCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.telPrintFlag = item.printFlag;
                                }else if (item.sequence == 9) {
                                    this.notifier2.email = item.catalogContent;
                                    this.notifier2.emailCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.emailPrintFlag = item.printFlag;
                                }else if (item.sequence == 15) {
                                    this.notifier2.enterpriseCode = item.catalogContent;
                                    this.notifier2.enterpriseCodeCatalogId = item.bkCustomerCatalogId;
                                    this.notifier2.enterpriseCodePrintFlag = item.printFlag;
                                }else{
                                    this.notifier2.otherCatalogs.push(item);
                                }
                            })
                        }
                    })
                }
            },

            /************************************ 页面初始化 ************************************
             * 初始化基础数据
             */
            initCombos() {
                this.bookingStatusFocus();
                this.bookingTypeFocus();
                this.blTypeFocus();
                this.paidTypeFocus();
                this.portFocus();
                this.cargoTypeFocus();
                this.rateBaseFocus();
                this.containerTypeFocus();
                this.dgPackageGroupFocus();
                this.transportationTermsFocus();
                this.carrierFocus();
            },
            
            /**
             * 根据当前登录主体获取carrier值
             * @returns {string} carrier值 (ZGL 或 ZSS)
             */
            getCarrierByEntity() {
                const entityType = this.$apiUtils.getCurrentEntity();
                return entityType === "2" ? "ZSS" : "ZGL";
            },
        },
        mounted() {},
        created() {
            this.initCombos();
            this.initPageInfo();
            this.$parent.updateHeaderAside();
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../assets/scss/base.scss";
    @import "../../assets/scss/public.scss";

    .el-row {
        margin-bottom: 0;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .el-col {
        margin-bottom: 0;
        border-radius: 4px;
    }

    .packageTypeButton {
        width: 25px;
        height: 25px;
        margin-top: 2px;
    }

    .inputName-left {
        flex: 1;
        margin: 0 5px;
    }

    .cardBox {
        background: $colorA;
        margin-bottom: 20px;
        border: 1px solid #e8e8e8;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        padding: 16px 16px 1px 16px;
    }

    .lastCardBox {
        width: 59.5%;
        margin-right: 0.5%;
        height: 80px;
    }

    .lastCardBox2 {
        width: 59.5%;
        height: 80px;
    }

    .cardTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontE;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .collapseTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontE;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .collapseItem {
        margin-top: -16px;
    }

    .setting {
        justify-content: flex-start;

        ul {
            li {
                margin-right: 15px;
                color: #6d7278;
                font-size: $fontB;
            }
        }
    }

    .position-right {
        height: 20px;
        text-align: right;
    }

    .topMargin {
        margin-top: 20px;
    }

    .popoverInner {
        margin: 5px;
        margin-top: 0;
    }

    /deep/ .el-collapse-item__header {
        padding: 16px 16px 1px 16px;
    }

    /deep/ .el-collapse-item__content {
        padding: 16px 16px 1px 16px;
    }

    /deep/ .el-icon-arrow-right {
        border-radius: 50%;
        border: 2px solid #e8e8e8;
        color: #2867ce;
        font-size: $fontE;
        font-weight: 600;
    }

    .inputName {
        flex: 1;
        margin: 2px 5px;
        position: relative; // 为错误提示提供定位参考
    }

    .inputName ::v-deep.el-input.is-disabled .el-input__inner {
        background-color: #FFFFFF;
        border-color: #E4E7ED;
        color: black;
        cursor: not-allowed;
    }

    //重写el-input样式，只显示下边框
    .inputName ::v-deep.el-input__inner{
        border-radius: 0;// 去掉圆角
        border-left-width: 0;
        border-right-width: 0;
        border-top-width: 0;
        border-bottom-width: 1px;//只显示下边框
    }

    .inputName ::v-deep.el-input.is-disabled .el-input__inner {
        background-color: #FFFFFF;
        border-color: #E4E7ED;
        color: black;
        cursor: not-allowed;
    }

    // 字段错误提示样式
    // 使用绝对定位，不影响原有组件的布局和位置
    .field-error-tip {
        position: absolute;
        top: 100%; // 显示在输入框下方
        right: 0; // 靠右侧显示
        color: #f56c6c;
        font-size: 10.5px;
        line-height: 1.5;
        margin-top: 1px;
        padding: 0;
        z-index: 10; // 确保显示在其他元素上方
        word-break: break-word;
        background: transparent; // 透明背景，不遮挡其他内容
        pointer-events: none; // 不阻挡鼠标事件，允许点击下方的元素
        white-space: normal; // 允许换行
        text-align: right; // 文本右对齐
        max-width: 100%; // 限制最大宽度，避免超出容器
    }

    // textarea 字符数显示样式（显示在 textarea 右下角）
    .textarea-word-limit {
        position: absolute;
        bottom: 5px;
        right: 10px;
        color: #909399;
        font-size: 12px;
        background: rgba(255, 255, 255, 0.9);
        padding: 2px 5px;
        border-radius: 2px;
        pointer-events: none;
        z-index: 1;
    }

    // 自定义字符数显示样式
    .custom-word-limit {
        color: #909399;
        font-size: 12px;
        padding-right: 8px;
    }

    // 港口选择提示信息图标大小
    .port-selection-alert ::v-deep .el-alert__icon {
        font-size: 20px;
        width: 20px;
        height: 20px;
    }
</style>